import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getLogin } from '../service/adminApi';
import { getS3 } from '../utils/Download.js';
import { loginCredientials } from '../constant';
import { getDropdown, postBulkInterview, postExpBulkInterview, postHireStage, updateSiblings } from '../service/RecruiterApi';
import { OnlyNumberAndSpecialChar, NotificationTrigger, OnlyNu, OnlyNumberAndSpecialCharmberAlphabetSpace, OnlyNumberAlphabetSpace } from '../../src/utils/RegHandling';
import {
    getInterviewRound,
    postExpInterview,
    postInterview,
    getScheduledInterview,
    getInterviewers,
    deleteScheduledInterview,
    sendFeedback,
    getEditScheduledInterview,
    updateExpInterview,
    updateInterview,
    sendMail,
    getInterviewRoundName,
    postTimeline,
    getLogin1,
    directory,
    getJob,
    postStage,
    postStages,
    getTeamsInvite,
    getLoginEmailId,
    updateFresherStatus,
    updateExpStatus,
    updateFeedBackData,
} from '../service/RecruiterApi';

import Loader from '../StaticComponent/Loader';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import Popup from './ConformationPopup/Popup';
import DOMPurify from 'dompurify';
import { encryptStorage } from '../constant';
import { event } from 'jquery';

function CandidateInterview(props) {
    let UserName = encryptStorage.getItem('username');
    let UserId = encryptStorage.getItem('employeeId');
    const search = window.location.search;
    let job_id = new URLSearchParams(search).get('jId');

    const candidateName = props.candidateName;

    //PS_CB_02
    let scheduledInterviewObj = {
        candidate_id: props.candidate_id,
        interview_id: '',
        recommendation_id: '',
        status: '',
        attitude: '',
        communication: '',
        business: '',
        technology: '',
        overAllComments: '',
        is_check: false,
        experience: '',
        interview_round_name: '',
        statusResult: 'Select',
        reason_for_reschedule: '',
        ctc: '',
        domain: '',
        current_location: '',
        native_location: '',
        father_occupation: '',
        father_salary: '',
        mother_occupation: '',
        mother_salary: '',
        siblings: [{ id: null, occupation: '', salary: '' }]
    };

    let interViewObject = {
        candidate_id: '',
        job_id: job_id || '',
        title: '',
        meeting_details: '',
        interview_round_id: '',
        interview_date: '',
        start_time: '',
        end_time: '',
        local_start_time: '',
        local_end_time: '',
        interviewers: UserId,
        candidates: '',
        scheduled_by: '',
        interview_round_name: '',
        time_interval: '',
        availability: true,
        availabilityStatus: 'Available',
        comments: ''
    };
    let interViewObject1 = {
        candidate_id: '',
        job_id: job_id || '',
        title: '',
        meeting_details: '',
        interview_round_id: '',
        interview_date: '',
        start_time: '',
        end_time: '',
        local_start_time: '',
        local_end_time: '',
        interviewers: UserId,
        candidates: '',
        scheduled_by: '',
        interview_round_name: '',
    };

    const [scheduledInterviewData, setScheduledInterviewData] = useState({
        Name: '',
        position: '',
        stage: '',
        scheduled: '',
        date: '',
        duration: '',
    });
    const [interviewData, setInterviewData] = useState(interViewObject);
    const [startEndTime, setstartEndTime] = useState(interViewObject1);
    const [showFeedback, setShowFeedback] = useState(false);
    const [interviewRound, setInterviewRound] = useState();
    const [interviewRoundDD, setInterviewRoundDD] = useState([]);
    const [interviewRoundEdit, setInterviewRoundEdit] = useState([]);
    const [submitInterviewMode, setSubmitInterviewMode] = useState('Insert');
    const [interviewersDD, setInterviewersDD] = useState([]);
    let [viewFeedbackData, setViewFeedbackData] = useState([]);
    let [feedbackView, setFeedbackView] = useState([]);
    const [interViews, setInterViews] = useState([]);
    const [JobTitle, setJobTitle] = useState();
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [selectedCandidate, setSelectedCandidate] = useState([]);
    let [showEmployee, setShowEmployee] = useState([]);
    let [showCandidate, setShowCandidate] = useState([]);
    const [AddFeedBack, setAddFeedBack] = useState(scheduledInterviewObj);
    const [message, setMessage] = useState(scheduledInterviewObj);
    const [isLoadingLoaderFeedback, setIsLoadingLoaderFeedback] = useState(true);
    const [InterviewRounds, setInterviewRounds] = useState();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(true);
    let [titleValidation, setTitleValidation] = useState('');
    let [meetingDetailsValidation, setMeetingDetailsValidation] = useState('');
    let [interviewRoundValidation, setInterviewRoundValidation] = useState('');
    let [interviewerValidation, setInterviewersValidation] = useState('');
    let [candidatesValidation, setCandidatesValidation] = useState('');
    let [dateValidation, setDateValidation] = useState('');
    let [startTimeValidation, setStartTimeValidation] = useState('');
    let [endTimeValidation, setEndTimeValidation] = useState('');
    let [interViewsArray, setinterViewsArray] = useState([]);
    const [emp, setEmp] = useState([]);
    const [selectedRound, setSelectedRound] = useState('');
    let [hideFeedback, setHideFeedback] = useState(false);
    let [hideViewFeedback, setHideViewFeedback] = useState(false);
    let [hideScheduleInterview, setHideScheduleInterview] = useState(false);
    const [renderFlag, setRenderFlag] = useState(true);
    const [deleteInterviewIndex, setDeleteInterviewIndex] = useState();
    const [showContainer, setShowContainer] = useState(false);
    const [isLoadingLoader, setIsLoadingLoader] = useState(true);
    const [greenSelect, setGreenselect] = useState();
    const [redreject, setredreject] = useState();
    const [rednoShow, setrednoShow] = useState();
    //PC_FB_01 -> state variables are declared and assigned to responding values
    const [feedBackDisabled, setFeedBackDisabled] = useState(true);
    const [updateButton, setUpdateButton] = useState('');
    const [domain, setDomain] = useState('');
    const [commentsValidation, setCommentsValidation] = useState('')
    const [isOffcanvasVisible, setOffcanvasVisible] = useState(false);
    const [imageUrls, setImageUrls] = useState({});
    useEffect(() => {
        loadData();
        loadInterviews();
        setGreenselect('custom-task-green-btn font-14 regular-text');
        setredreject('custom-task-red-btn font-14 regular-text me-2');
        setrednoShow('custom-task-red-btn font-14 regular-text me-2');
        setIsLoadingLoader(true);
    }, [props.jobId, renderFlag]);

    useEffect(() => {
        (async () => {
            const url = props.candidate_profile_url ? await getS3(props.candidate_profile_url) : '/Images/candidate-prof.svg';
            setImageUrls({ ...imageUrls, candidate: url });
        })();
    }, [props.candidate_profile_url]);

    let loadData = async () => {
        try {
            setIsLoadingLoader(false);
            let res = await getInterviewers({ job_id: job_id });
            setInterviewersDD(res.data.data);

            let val = await getJob({ job_id: job_id });

            setJobTitle(val.data.data[0].job_title);
            let resp = await getDropdown();          		//Add
            setDomain(resp.data.data[0]);
            // setRecommendationDD(resp.data.data[1]);
            // bind();
        } catch (e) { }
    };

    let loadInterviews = async () => {
        try {
            setIsLoadingLoader(false);

            // Fetch scheduled interviews
            let resp1 = await getScheduledInterview({
                id: props.candidate_id,
                experience: props.experience,
            });

            // Process feedback data
            resp1.data.data.forEach((interview) => {
                if (interview.feedback && interview.feedback[0] && interview.feedback[0].siblings) {
                    interview.feedback[0].siblings = interview.feedback[0].siblings.map(sibling => ({
                        id: sibling.id,
                        occupation: sibling.sibling_occupation,
                        salary: sibling.sibling_salary
                    }));
                }
            });

            setInterViews(resp1.data.data);

            // Fetch interview rounds
            let resp = await getInterviewRound({ job_id });

            let availableRounds = resp.data.data[0];
            let scheduledInterviews = resp1.data.data;

            // Filter available rounds
            // let filteredRounds = availableRounds.filter(round => {
            //     // Check if this round is not yet scheduled or if it was scheduled but rejected
            //     let isAvailable = !scheduledInterviews.some(interview =>
            //         interview.interview_round_name === round.interview_round_name &&
            //         (!interview.feedback[0] || interview.feedback[0].overall_recommendation_id !== 4)
            //     );

            //     return isAvailable;
            // });

            setInterviewRoundDD(availableRounds);
            setInterviewRoundEdit(availableRounds.map(round => round.interview_round_name));

            bind();
        } catch (e) {
            console.error("Error in loadInterviews:", e);
        }
    }
    const constructIdsArray = (arr) => {
        let ids = [];
        arr.map((obj, index) => {
            if (!ids.includes(obj.interview_id)) {
                ids.push(obj.interview_id);
            }
        });
        return ids;
    };
    const seperateBasedOnId = (requestObject) => {
        let idsArray = constructIdsArray(requestObject);
        let wholeObjectArray = [];
        idsArray.map((id, i1) => {
            let idBasedObjectArray = [];
            requestObject.map((obj, i2) => {
                if (obj.interview_id == id) {
                    idBasedObjectArray.push(obj);
                }
            });
            wholeObjectArray.push(idBasedObjectArray);
        });
        return wholeObjectArray;
    };
    const mergeInterviewArray = (objsamp) => {
        let assessment = [];
        let localInterviewObject = [];
        if (objsamp?.length > 0) {
            objsamp.map((obj, index) => {
                let object = {
                    assessment_name: obj.assessment_name,
                    assessment_comments: obj.assessment_comments,
                    overall_comments: obj.overall_comments,
                };
                assessment.push(object);
            });
            localInterviewObject = objsamp[0];
            localInterviewObject.assessment = assessment;
            return localInterviewObject;
        }
    };

    let onInterviewValue = (e) => {
        let istStartTime = '';
        let istEndTime = '';

        // First, handle the availability status change
        if (e.target.name === 'availabilityStatus') {
            const newAvailabilityStatus = e.target.value;
            setInterviewData(prevData => ({
                ...prevData,
                availabilityStatus: newAvailabilityStatus,
                availability: newAvailabilityStatus === 'Available'
            }));

            // Reset validations and fields based on availability status
            if (newAvailabilityStatus === 'Not Available') {
                setTitleValidation('');
                setMeetingDetailsValidation('');
                setDateValidation('');
                setStartTimeValidation('');
                setEndTimeValidation('');
                // Reset fields that are not applicable for 'Not Available'
                setInterviewData(prevData => ({
                    ...prevData,
                    title: '',
                    meeting_details: '',
                    interview_date: '',
                    local_start_time: '',
                    local_end_time: '',
                    time_interval: ''
                }));
            } else {
                // Reset 'Not Available' specific fields
                setInterviewData(prevData => ({
                    ...prevData,
                    comments: ''
                }));
            }
            return; // Exit the function early as we've handled the availability change
        }

        // Only proceed with other validations if the status is 'Available'
        if (interviewData.availabilityStatus === 'Available') {
            if (e.target.id === 'title' && e.target.value !== '') {
                setTitleValidation('');
            } else if (e.target.id === 'meeting_details' && e.target.value !== '') {
                setMeetingDetailsValidation('');
            } else if (e.target.id === 'interview_round_id' && e.target.value !== '') {
                setInterviewRoundValidation('');
            } else if (e.target.id === 'interview_date' && e.target.value !== '') {
                setDateValidation('');
            } else if (e.target.id === 'local_start_time' && e.target.value !== '') {
                setStartTimeValidation('');
                let starttimevalue = e.target.value;
                let end = starttimevalue.split(':');

                var currentTime = new Date();

                let arr = currentTime.toString().split(' ');
                arr[4] = `${end[0]}:${end[1]}:00`;
                currentTime = new Date(arr.join(' '));

                var currentOffset = currentTime.getTimezoneOffset();

                var ISTOffset = 330; // IST offset UTC +5:30

                var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

                // ISTTime now represents the time in IST coordinates

                var hoursIST = ISTTime.getHours();
                var minutesIST = ISTTime.getMinutes();
                var formattedMinutesIST = String(minutesIST).padStart(2, '0');
                istStartTime = hoursIST + ':' + formattedMinutesIST;
                istStartTime = hoursIST + ':' + minutesIST;
                let targetTime = moment(starttimevalue, 'HH:mm');
                let currentMomentTime = moment();
        
                if (interviewData.interview_date === currentMomentTime.format('YYYY-MM-DD')) {
                    if (targetTime.isBefore(currentMomentTime)) {
                        setStartTimeValidation('Valid Start Time is required');
                    } else {
                        setStartTimeValidation('');
                    }
                }
            }

            else if (e.target.id === 'local_end_time' && e.target.value !== '') {
                setEndTimeValidation('');
                let endtimevalue = e.target.value;
                let end = endtimevalue.split(':');

                var currentTime = new Date();

                let arr = currentTime.toString().split(' ');
                arr[4] = `${end[0]}:${end[1]}:00`;
                currentTime = new Date(arr.join(' '));

                var currentOffset = currentTime.getTimezoneOffset();

                var ISTOffset = 330; // IST offset UTC +5:30

                var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

                // ISTTime now represents the time in IST coordinates

                var hoursIST = ISTTime.getHours();
                var minutesIST = ISTTime.getMinutes();
                var formattedEndMinutesIST = String(minutesIST).padStart(2, '0');
                istEndTime = hoursIST + ':' + formattedEndMinutesIST;
                istEndTime = hoursIST + ':' + minutesIST;

                let targetTime = moment(endtimevalue, 'HH:mm');
                               let currentMomentTime = moment();
                       
                               if (interviewData.interview_date === currentMomentTime.format('YYYY-MM-DD')) {
                                   if (targetTime.isBefore(currentMomentTime)) {
                                       setEndTimeValidation('Valid End Time is required1');
                                   } else {
                                       setEndTimeValidation('');
                                   }
                }
            }
        }

        // Handle comments for 'Not Available'
        if (e.target.id === 'comments') {
            setInterviewData(prevData => ({ ...prevData, comments: e.target.value }));
            setCommentsValidation('')
        }
        // Update the interviewData state
        if (e.target.id === 'local_end_time') {
            setInterviewData(prevData => ({ ...prevData, end_time: istEndTime, local_end_time: e.target.value }));
        } else if (e.target.id === 'local_start_time') {
            setInterviewData(prevData => ({ ...prevData, start_time: istStartTime, local_start_time: e.target.value }));
        } else if (e.target.id == 'interview_round_id') {
            const selectedOption = e.target.options[e.target.selectedIndex];
            setInterviewData(prevData => ({
                ...prevData,
                interview_round_id: e.target.value,
                interview_round_name: selectedOption.text
            }));
        }
        else {
            setInterviewData(prevData => ({ ...prevData, [e.target.id]: e.target.value }));
        }
    };

    let handleChange = (e) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        setEmp(attend);
    };
    //PC_FB_10 ->handleFeedbackChange() is defined
    // let handleFeedbackChange = (e, index = null) => {
    //     // //debugger;
    //     // if (e.target.id == 'recommendation_id') {
    //     //     if (e.target.value == 1) {
    //     //         setGreenselect('custom-task-green font-14 regular-text');
    //     //         setredreject('custom-task-red-btn font-14 regular-text me-2');
    //     //         setrednoShow('custom-task-red-btn font-14 regular-text me-2');
    //     //     } else if (e.target.value == 2) {
    //     //         setGreenselect('custom-task-green-btn font-14 regular-text');
    //     //         setredreject('custom-task-red font-14 regular-text me-2');
    //     //         setrednoShow('custom-task-red-btn font-14 regular-text me-2');
    //     //     } else if (e.target.value == 3) {
    //     //         setGreenselect('custom-task-green-btn font-14 regular-text');
    //     //         setredreject('custom-task-red-btn font-14 regular-text me-2');
    //     //         setrednoShow('custom-task-red font-14 regular-text me-2');
    //     //     }
    //     // }

    //     if (e.target.name == 'statusResult') {
    //         setAddFeedBack({
    //             ...AddFeedBack,
    //             recommendation_id: parseInt(e.target.id),
    //             [e.target.name]: e.target.text,
    //             // Clear other fields if status is Reschedule
    //             attitude: e.target.id == 6 ? '' : AddFeedBack.attitude,
    //             communication: e.target.id == 6 ? '' : AddFeedBack.communication,
    //             business: e.target.id == 6 ? '' : AddFeedBack.business,
    //             technology: e.target.id == 6 ? '' : AddFeedBack.technology,
    //             overAllComments: e.target.id == 6 ? '' : AddFeedBack.overAllComments,
    //             father_occupation: e.target.id == 6 ? '' :  AddFeedBack.father_occupation,
    //             father_salary: e.target.id == 6 ? '' :  AddFeedBack.father_salary,
    //             mother_occupation: e.target.id == 6 ? '' :  AddFeedBack.mother_occupation,
    //             mother_salary: e.target.id == 6 ? '' :  AddFeedBack.mother_salary,
    //             siblings: e.target.id == 6 ? [] : AddFeedBack.siblings,
    //             current_location: e.target.id == 6 ? '' :  AddFeedBack.current_location,
    //             native_location: e.target.id == 6 ? '' :  AddFeedBack.native_location,
    //             ctc: e.target.id == 6 ? '' :  AddFeedBack.ctc,
    //             domain: e.target.id == 6 ? '' :  AddFeedBack.domain,
    //             reason_for_reschedule: e.target.id == 6 ? AddFeedBack.reason_for_reschedule : ''
    //         });
    //     } else if (index !== null) {
    //         // Handle sibling fields
    //         const updatedSiblings = [...AddFeedBack.siblings];
    //         updatedSiblings[index][e.target.name] = e.target.value;
    //         setAddFeedBack({ ...AddFeedBack, siblings: updatedSiblings });
    //       } 
    //     else{
    //         setAddFeedBack({ ...AddFeedBack, [e.target.id]: e.target.value });
    //     }
    // };
    const isAlphanumericWithSpace = (str) => {
        const regex = /^[a-zA-Z0-9 ]*$/;
        return regex.test(str);
    };
    let handleFeedbackChange = (e, index = null) => {
        if (e.target.name === 'statusResult') {
            setAddFeedBack({
                ...AddFeedBack,
                recommendation_id: parseInt(e.target.id),
                candidate_id: props.candidate_id, 
                [e.target.name]: e.target.text,
                // Clear other fields if status is Reschedule
                attitude: e.target.id == 6 ? '' : AddFeedBack.attitude,
                communication: e.target.id == 6 ? '' : AddFeedBack.communication,
                business: e.target.id == 6 ? '' : AddFeedBack.business,
                technology: e.target.id == 6 ? '' : AddFeedBack.technology,
                overAllComments: e.target.id == 6 ? '' : AddFeedBack.overAllComments,
                father_occupation: e.target.id == 6 ? '' : AddFeedBack.father_occupation,
                father_salary: e.target.id == 6 ? '' : AddFeedBack.father_salary,
                mother_occupation: e.target.id == 6 ? '' : AddFeedBack.mother_occupation,
                mother_salary: e.target.id == 6 ? '' : AddFeedBack.mother_salary,
                siblings: e.target.id == 6 ? [] : AddFeedBack.siblings,
                current_location: e.target.id == 6 ? '' : AddFeedBack.current_location,
                native_location: e.target.id == 6 ? '' : AddFeedBack.native_location,
                ctc: e.target.id == 6 ? '' : AddFeedBack.ctc,
                domain: e.target.id == 6 ? '' : AddFeedBack.domain,
                reason_for_reschedule: e.target.id == 6 ? AddFeedBack.reason_for_reschedule : ''
            });
        } else if (index !== null) {
            // Handle sibling fields
            const updatedSiblings = [...AddFeedBack.siblings];
            if (e.target.name === 'salary') {
                updatedSiblings[index][e.target.name] = e.target.value.toUpperCase() === 'NA' ? 'NA' : e.target.value;
            } else {
                updatedSiblings[index][e.target.name] = e.target.value;
            }
            setAddFeedBack({ ...AddFeedBack, siblings: updatedSiblings });
        } else if (e.target.id === 'father_salary' || e.target.id === 'mother_salary') {
            // Handle father and mother salary fields
            setAddFeedBack({
                ...AddFeedBack,
                [e.target.id]: e.target.value.toUpperCase() === 'NA' ? 'NA' : e.target.value
            });
        } else if (e.target.id === 'ctc') {
            if (isAlphanumericWithSpace(e.target.value)) {
                setAddFeedBack({ ...AddFeedBack, ctc: e.target.value });
                setMessage({ ...message, ctc: '' });
            } else {
                setMessage({ ...message, ctc: 'Valid CTC is required' });
            }
        } else {
            // Handle all other fields
            setAddFeedBack({ ...AddFeedBack, [e.target.id]: e.target.value });
        }
    };
    //PS_PD_11 - It is used to add another sibling records
    // const addSibling = () => {
    //     setAddFeedBack({
    //       ...AddFeedBack,
    //       siblings: [...AddFeedBack.siblings, {id:null, occupation: '', salary: '' }]
    //     });
    //   };
    const addSibling = () => {
        setAddFeedBack(prevState => ({
            ...prevState,
            siblings: [...prevState.siblings, { id: null, occupation: '', salary: '' }]
        }));
    };
    //PS_PD_13 - it is used to remove sibling records

    const removeSibling = async (sibling, index) => {
        try {

            if (sibling.id === null) {
                // If sibling.id is null, directly remove from local state without API call
                setAddFeedBack(prevState => ({
                    ...prevState,
                    siblings: prevState.siblings.filter((_, i) => i !== index)
                }));
            } else {
                // If sibling.id is not null, proceed with API call
                const requestPayload = {
                    id: sibling.id,
                    exp: props.experience,
                    candidate_id: props.candidate_id
                };
                const response = await updateSiblings(requestPayload);

                // Check if the API call was successful
                if (response.data.statusCode === 200) {
                    // Update the local state to remove the sibling
                    setAddFeedBack(prevState => ({
                        ...prevState,
                        siblings: prevState.siblings.filter((_, i) => i !== index)
                    }));
                } else {
                    // Handle API error
                    console.error("Failed to remove sibling:", response.error);
                    // You might want to show an error message to the user here
                }
            }
        } catch (error) {
            console.error("Error removing sibling:", error);
            // Handle any unexpected errors
            // You might want to show an error message to the user here
        }
    };

    let bindDomain = () => {
        try {
            const sortedDomain = [...domain].sort((a, b) =>
                a.department.localeCompare(b.department)
            );
            return sortedDomain.map((obj, index) => {
                return (
                    <option key={index} value={obj.department}>
                        {obj.department}
                    </option>
                );
            });
        } catch (e) { }
    };
    let timeDiff = (stime, etime) => {
        // ;
        var start = stime.split(':');
        var end = etime.split(':');

        var date1 = new Date(2000, 0, 1, start[0], start[1]);
        var date2 = new Date(2000, 0, 1, end[0], end[1]);
        var dif = date2 - date1;

        var msec = dif;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        if (hh == 0) {
            return mm + ' mins';
        } else if (hh == 1) {
            return hh == 1 && mm == 0 ? hh + ' hr' : hh + ' hr ' + mm + ' mins';
        } else if (hh > 1) {
            return hh > 1 && mm == 0 ? hh + ' hrs' : hh + ' hrs ' + mm + ' mins';
        } else {
            return '';
        }
    };
    let timeDiff2 = (stime, etime) => {
        var start = stime.split(':');
        var end = etime.split(':');

        var date1 = new Date(2000, 0, 1, start[0], start[1]);
        var date2 = new Date(2000, 0, 1, end[0], end[1]);
        var diff = (date2 - date1) / 60000; // Convert milliseconds to minutes

        return diff;
    };
    // const diff = timeDiff(interviewData.start_time, interviewData.end_time);

    const validateMeetingDetails = (value) => {
        if (value.trim() === '') {
            return true;
        }
        // Create a regular expression to check if the value contains at least one alphabet character.
        const regex = /^(?!\s*$)(?=.*[a-zA-Z]).*$/;
        //validate if the value contains alphabet characters, doesn't allow numbers and special characters.
        return regex.test(value);
    };

    let validation = (start, end) => {
        let result = true;
        let checkregex = OnlyNumberAndSpecialChar(interviewData.title);
        if (interviewData.title == '') {
            setTitleValidation('Title is required');
        } else if (!validateMeetingDetails(interviewData.title)) {
            setTitleValidation('Valid Title is required');
            result = false;
        } else {
            setTitleValidation('');
        }
        // if (interviewData.meeting_details == '') {
        //     setMeetingDetailsValidation('Meeting Details is required');
        // }
        if (interviewData.interview_round_id == '') {
            setInterviewRoundValidation('Interview round is required');
        }
        if (interviewData.interview_date == '') {
            setDateValidation('Interview date  is required');
        }
        if (interviewData.start_time == '') {
            setStartTimeValidation('Start Time is required');
        }
        if (interviewData.end_time == '') {
            setEndTimeValidation('End Time is required');
        } else if (end < start) {
            setEndTimeValidation('Valid End time is required');
        }else if (Date.parse('01/01/2011 ' + interviewData.end_time) <= Date.parse('01/01/2011 ' + interviewData.start_time)) {
                setEndTimeValidation('End time should be greater than start time');
                result = false;
        } else if (timeDiff2(interviewData.start_time, interviewData.end_time) < 10) {
            setEndTimeValidation('End time should be at least 10 minutes after start time');
            result = false;
        } else {
            setEndTimeValidation('');
        }

        if (selectedPeopleList.length == 0) {
            setInterviewersValidation('Interviewers is required');
        }
        if (!validateMeetingDetails(interviewData.meeting_details)) {
            setMeetingDetailsValidation('Valid Meeting Details is required');
            result = false;
        } else if (interviewData.meeting_details == '') {
            setMeetingDetailsValidation('');
        } else {
            setMeetingDetailsValidation('');
        }
        let date = new Date();

        let dates = moment(date).format('YYYY-MM-DD');

        let convertedStartTime;
        let convertedEndTime;

        if (interviewData.interview_date == dates) {
            let currentTime = new Date().toLocaleTimeString();
            convertedStartTime = moment(currentTime, 'hh:mm A').format('HH:mm');

            if (interviewData.local_start_time < convertedStartTime) {
                setStartTimeValidation('Valid Start Time is required');
            } 
        }
        if (interviewData.interview_date == dates) {
            let currentTime = new Date().toLocaleTimeString();
            let convertedEndTime = moment(currentTime, 'hh:mm A').format('HH:mm');

            if (interviewData.local_end_time < convertedEndTime) {
                setEndTimeValidation('Valid End Time is required');
            } 
        }

        // let check = OnlyNumberAndSpecialChar(interviewData.meeting_details);
        // if (check) {
        //     setMeetingDetailsValidation('Valid Meeting Details is required');
        //     result = false;
        // } else {
        //     setMeetingDetailsValidation('');
        // }

        if (
            interviewData.title != '' &&
            interviewData.interview_round_id != '' &&
            interviewData.interview_date != '' &&
            interviewData.start_time != '' &&
            interviewData.end_time != '' &&
            start < end &&
            selectedPeopleList.length !== 0
        ) {
            if (interviewData.interview_date == dates) {
                let currentTime = new Date().toLocaleTimeString();
                let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                if (interviewData.local_start_time < convertedTime) {
                    setStartTimeValidation('Valid Start Time is required');
                    result = false;
                } 
            }
            if (interviewData.interview_date == dates) {
                let currentTime = new Date().toLocaleTimeString();
                let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                if (interviewData.local_end_time < convertedTime) {
                    setEndTimeValidation('Valid End Time is required');
                    result = false;
                } 
            }

            let checkregex = OnlyNumberAndSpecialChar(interviewData.title);
            if (checkregex) {
                setTitleValidation('Valid Title is required');
                result = false;
            } else {
                setTitleValidation('');
            }
            // let check = OnlyNumberAndSpecialChar(interviewData.meeting_details);
            // if (checkregex) {
            //     setMeetingDetailsValidation('Valid Meeting Details is required');
            //     result = false;
            // } else {
            //     setMeetingDetailsValidation('');
            // }
        } else {
            result = false;
        }
        return result;
    };

    function formatTime(time) {
        const [hours, minutes] = time.split(':');
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    }

    const validateNotAvailable = () => {
        if (!interviewData.interview_round_id) {
            setInterviewRoundValidation('Please select an interview round');
            return false;
        }
        if (!interviewData.comments.trim()) {
            // Assuming you have a state for comments validation
            setCommentsValidation('Please provide a reason for unavailability');
            return false;
        }
        return true;
    };

    let scheduleInterviewClick = async () => {
        let teams_start = interviewData.start_time.split(':');
        let teams_end = interviewData.end_time.split(':');

        let interview_start_time;
        let interview_end_time;
        let newstart, newstart1;
        let newend, newend1;
        if (interviewData.availabilityStatus === 'Available') {
            if (teams_start[1] >= 0 && teams_start[1] < 10 && Math.floor(teams_start[1]) == teams_start[1]) {
                newstart = `0${teams_start[1]}`;
                if (newstart.length == 3) {
                    newstart = newstart.slice(1, 3);
                }

                // interview_start_time = `${teams_start[0]}:${newstart}`;
            } else {
                newstart = teams_start[1];
                // interview_start_time = interviewData.start_time;
            }
            if (teams_end[1] >= 0 && teams_end[1] < 10 && Math.floor(teams_end[1]) == teams_end[1]) {
                newend = `0${teams_end[1]}`;
                if (newend.length == 3) {
                    newend = newend.slice(1, 3);
                }

                // interview_end_time = `${teams_end[0]}:${newend}`;
            } else {
                // interview_end_time = interviewData.end_time;
                newend = teams_end[1];
            }

            if (teams_start[0] >= 0 && teams_start[0] < 10 && Math.floor(teams_start[0]) == teams_start[0]) {
                newstart1 = `0${teams_start[0]}`;
                if (newstart1.length == 3) {
                    newstart1 = newstart1.slice(1, 3);
                }

                // interview_start_time = `${teams_start[0]}:${newstart}`;
            } else {
                newstart1 = teams_start[0];
                // interview_start_time = interviewData.start_time;
            }
            if (teams_end[0] >= 0 && teams_end[0] < 10 && Math.floor(teams_end[0]) == teams_end[0]) {
                newend1 = `0${teams_end[0]}`;
                if (newend1.length == 3) {
                    newend1 = newend1.slice(1, 3);
                }

                // interview_end_time = `${teams_end[0]}:${newend}`;
            } else {
                newend1 = teams_end[0];
                // interview_end_time = interviewData.end_time;
            }
            interview_end_time = `${newend1}:${newend}`;
            interview_start_time = `${newstart1}:${newstart}`;

            let start = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_start_time}:00+05:30`;

            let end = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_end_time}:00+05:30`;

            let Hour = timeDiff(interviewData.start_time, interviewData.end_time);
            let response;
            interviewData.candidate_id = props.candidate_id;
            interviewData.job_id = job_id;
            interviewData.candidates = props.candidate_id;

            let val = selectedPeopleList;
            let arrEmail = [];

            let obj = {};
            // ;
            for (let i = 0; i < selectedPeopleList.length; i++) {
                obj[i + 1] = selectedPeopleList[i].username;
                arrEmail.push(selectedPeopleList[i].email_id);
            }
            arrEmail.push(props.email);
            interviewData.scheduled_by = obj;

            if (validation(start, end) == true) {
                setIsLoadingLoader(false);
                let insertdata = interviewData;
                let teams = {
                    startDateTime: start,
                    endDateTime: end,
                    subject: interviewData.interview_round_name,
                };
                let teamsInvite = await getTeamsInvite(teams);

                insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
                if (submitInterviewMode == 'Insert') {
                    if (props.experience == 'Fresher') {
                        response = await postInterview(insertdata);
                    } else if (props.experience == 'Experienced') {
                        response = await postExpInterview(insertdata);
                    }
                    let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');

                    let reason = `Interview scheduled for ${JobTitle}- ${interviewData.interview_round_name} stage with ${candidateName}
                at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;

                    let payload = {
                        icon_category: 'Meeting',
                        candidateType: props.experience,
                        audit_reason: reason,
                        candidate_id: props.candidate_id,
                        job_id: job_id,
                    };

                    let response1 = await postTimeline(payload);
                    let data = {
                        exp: props.experience,
                        candidate_id: props.candidate_id,
                        stage: 'Interviews',
                    };
                    postStages(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });
                    interviewCancelClick();
                } else if (submitInterviewMode == 'Edit') {
                    let insertdata = interviewData;

                    let teams = {
                        startDateTime: start,
                        endDateTime: end,
                        subject: interviewData.interview_round_name,
                    };

                    let teamsInvite = await getTeamsInvite(teams);

                    insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
                    if (props.experience == 'Fresher') {
                        response = await updateInterview(insertdata);
                        let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
                        let reason = `Interview scheduled for ${JobTitle}- ${interviewData.interview_round_name} stage with ${candidateName}
                at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;
                        let payload = {
                            icon_category: 'Meeting',

                            candidateType: 'Fresher',

                            audit_reason: reason,

                            candidate_id: props.candidate_id,

                            job_id: job_id,
                        };

                        let response1 = await postTimeline(payload);
                    } else if (props.experience == 'Experienced') {
                        response = await updateExpInterview(insertdata);
                        let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
                        let reason = `Interview scheduled for ${JobTitle}- ${interviewData.interview_round_name} stage with ${candidateName}
                at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;
                        let payload = {
                            icon_category: 'Meeting',

                            candidateType: 'Experienced',

                            audit_reason: reason,

                            candidate_id: props.candidate_id,

                            job_id: job_id,
                        };

                        let response1 = await postTimeline(payload);
                    }

                    let data = {
                        exp: props.experience,
                        candidate_id: props.candidate_id,
                        stage: 'Interviews',
                    };
                    postStages(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });
                    interviewCancelClick();
                }
                loadInterviews();
                let data = {
                    modulename: 12,
                    methodname: 1,
                };

                // let res = await getLogin1(JSON.stringify(data));
                let res = await getLogin1(data);

                if (response.data.statusCode == 200) {
                    let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
                    let formattedStartTime = formatTime(interviewData.start_time);
                    let interview;

                    if (interviewData.interview_round_name == undefined) {
                        interview = 'Group Discussion';
                    } else {
                        interview = interviewData.interview_round_name;
                    }
                    let content = {
                        Subject: `Invite for ${interview}`,
                        body: `<html lang="en">
    
                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>
                    
                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                        </div>
                       </div>
                    
                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${candidateName},
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        As discussed, please join the ${interview} on ${date} at ${formattedStartTime} using below meeting link.<br/><br />
                        Teams invite link:<br/>
                        <a href="${teamsInvite?.data?.ResponseData?.joinWebUrl}">
                        ${teamsInvite?.data?.ResponseData?.joinWebUrl}</a><br/><br/>
                        Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${interviewData.job_id}"> https://hivecandidate.avasoft.com?id=${interviewData.job_id} </a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>
                      
                    </div>
                    </body>
                    </html>`,
                        to: [arrEmail],
                    };
                    sendMail(content);
                }
            }
            setRenderFlag(!renderFlag);
            setIsLoadingLoader(true);
            setShowContainer(false);
        }
        else if (interviewData.availabilityStatus === 'Not Available') {
            if (!validateNotAvailable()) {
                // If validation fails, exit the function early
                setOffcanvasVisible(true);
                return;
            }
            let response;
            let ids = [];
            // let obj = {};
            interviewData.candidate_id = props.candidate_id;
            interviewData.job_id = job_id;
            interviewData.candidates = props.candidate_id;

            let val = selectedPeopleList;
            let arrEmail = [];

            let obj = {};
            // //debugger;
            for (let i = 0; i < selectedPeopleList.length; i++) {
                obj[i + 1] = selectedPeopleList[i].username;
                arrEmail.push(selectedPeopleList[i].email_id);
            }
            arrEmail.push(props.email);
            interviewData.scheduled_by = obj;
            let insertdata = interviewData

            if (submitInterviewMode == 'Insert') {
                let ids = [];
                ids.push(props.candidate_id)
                insertdata.candidate_id = ids
                if (props.experience == 'Fresher') {
                    setIsLoading(false);
                    response = await postBulkInterview(insertdata);
                    setIsLoading(true);

                    let data1 = {
                        exp: props.experience,
                        candidate_id: props.candidate_id,
                        stage: 'Interviews',
                    };
                    postStages(data1).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });

                    let data = {
                        exp: props.experience,
                        candidate_id: ids,
                        stage: 'Screening',
                        stages: 'Interviews',
                    }

                    postHireStage(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });


                } else if (props.experience == 'Experienced') {
                    setIsLoading(false);
                    response = await postExpBulkInterview(insertdata);
                    setIsLoading(true);

                }
                let data1 = {
                    exp: props.experience,
                    candidate_id: props.candidate_id,
                    stage: 'Interviews',
                };
                postStages(data1).then((res) => {
                    if (res.data.statusCode == 200) {
                    }
                });
                let data = {
                    exp: props.experience,
                    candidate_id: ids,
                    stage: 'Interviews',
                };
                postHireStage(data).then((res) => {

                    if (res.data.statusCode == 200) {
                    }
                });
                interviewCancelClick();

            }
            // }
            interviewCancelClick();
            setShowCandidate([])
            setRenderFlag(!renderFlag);
        }
        else {
            setIsLoadingLoader(true);
        }
    };

    let bindInterviewRound = () => {
        try {
            return interviewRoundDD.map((obj, index) => {
                return (
                    <option key={obj.interview_round_name} value={obj.id}>
                        {obj.interview_round_name}
                    </option>
                );
            });
        } catch (e) { }
    };

    let cancelClick = () => {
        let viewFeedbackData = [];
        setViewFeedbackData(viewFeedbackData);
        setAddFeedBack({
            candidate_id: '',
            interview_id: '',
            recommendation_id: '',
            status: '',
            attitude: '',
            communication: '',
            business: '',
            technology: '',
            overAllComments: '',
            experience: '',
            interview_round_name: '',
            reason_for_reschedule: '',
            father_salary: '',
            father_occupation: '',
            mother_occupation: '',
            mother_salary: '',
            current_location: '',
            native_location: '',
            ctc: '',
            domain: '',
            siblings: [{ occupation: '', salary: '' }]
        });
        setShowFeedback(false);
        setRenderFlag(!renderFlag);
        setFeedBackDisabled(true);
        setUpdateButton('Edit');
    };

    let interviewCancelClick = () => {
        setOffcanvasVisible(false)
        setInterviewData({
            title: '',
            meeting_details: '',
            interview_round_id: '',
            interview_date: '',
            start_time: '',
            end_time: '',
        });
        bind();
        setTitleValidation('');
        setMeetingDetailsValidation('');
        setInterviewRoundValidation('');
        setInterviewersValidation('');
        setCandidatesValidation('');
        setDateValidation('');
        setStartTimeValidation('');
        setEndTimeValidation('');
        setShowContainer(false);
    };

    let interviewIconClick = async (value) => {
        let response;
        if (value == 'Add') {
        } else if (value == 'Edit') {
            response = await getScheduledInterview();
            setIsLoading(true);
        }
    };
    //PC_FB_07 -> updateCandidateFeedback() function is defined, the condition is checked for Edit/View and the data is passed as parameter in sendFeedback() and the feedback will be updated
    let updateCandidateFeedback = async (e) => {

        // if (scheduledInterviewData.stage === 'Group Discussion') {
        //     // Handle Group Discussion update
        //     let updatedData = {
        //         ...AddFeedBack,
        //         overall_comments: AddFeedBack.overAllComments,
        //         // Add other necessary fields
        //     };

        //     let updateResponse = await sendFeedback(updatedData);

        //     if (updateResponse.data.statusCode == 200) {
        //         setIsLoadingLoader(true);
        //         setFeedBackDisabled(true);
        //         setUpdateButton('Edit');
        //         setRenderFlag(!renderFlag);
        //     }
        //     return
        // }

        let isValid = true;

        if (e.target.value == 'Edit') {
            setFeedBackDisabled(false);
            setUpdateButton('Update');
            //PC_FB_13 -> condition for target value is checked for Update
        }
        else if (e.target.value == 'Update') {

            let data = {
                ...AddFeedBack,
                candidate_id: props.candidate_id, 
                reason_for_reschedule: AddFeedBack.recommendation_id == 6 ? AddFeedBack.reason_for_reschedule : '',
                attitude: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.attitude,
                communication: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.communication,
                business: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.business,
                technology: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.technology,
                overAllComments: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.overAllComments,
                father_occupation: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.father_occupation,
                father_salary: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.father_salary,
                mother_occupation: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.mother_occupation,
                mother_salary: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.mother_salary,
                current_location: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.current_location,
                native_location: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.native_location,
                ctc: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.ctc,
                domain: AddFeedBack.recommendation_id == 6 ? '' : AddFeedBack.domain,
                siblings: AddFeedBack.recommendation_id == 6 ? [] : AddFeedBack.siblings.map(sibling => ({
                    id: sibling.id,
                    occupation: sibling.occupation,
                    salary: sibling.salary
                }))
            };



            // condition for status is checked for empty or undefined
            if (data.recommendation_id == '' || data.recommendation_id == undefined) {
                message.status = 'Status is required';
                setMessage({ ...message });
            } else {
                message.status = '';
                setMessage({ ...message });
            }
            //PC_FB_14 -> condition for attitude is checked for emtpy string
            if (data.recommendation_id != 6) {
                if (data.attitude == '') {
                    message.attitude = 'Attitude is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.attitude);
                    if (checkregex) {
                        message.attitude = 'Valid attitude is required';
                        setMessage({ ...message });
                    } else {
                        message.attitude = '';
                        setMessage({ ...message });
                    }
                }
            }
            //PC_FB_15 -> condition for communication is checked for emtpy string
            if (data.recommendation_id != 6) {
                if (data.communication == '') {
                    message.communication = 'Communication is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.communication);
                    if (checkregex) {
                        message.communication = 'Valid communication is required';
                        setMessage({ ...message });
                    } else {
                        message.communication = '';
                        setMessage({ ...message });
                    }
                }
            }
            //PC_FB_16 -> condition for business is checked for emtpy string
            if (data.recommendation_id != 6) {
                if (data.business == '') {
                    message.business = 'Business is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.business);
                    if (checkregex) {
                        message.business = 'Valid business is required';
                        setMessage({ ...message });
                    } else {
                        message.business = '';
                        setMessage({ ...message });
                    }
                }
            }
            //PC_FB_17 -> condition for technology is checked for emtpy string
            if (data.recommendation_id != 6) {
                if (data.technology == '') {
                    message.technology = 'Technology is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.technology);
                    if (checkregex) {
                        message.technology = 'Valid technology is required';
                        setMessage({ ...message });
                    } else {
                        message.technology = '';
                        setMessage({ ...message });
                    }
                }
            }
            //Father occ
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.father_occupation == '') {
                    message.father_occupation = 'Father Occupation is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.father_occupation);
                    if (checkregex) {
                        message.father_occupation = 'Valid Father Occupation is required';
                        setMessage({ ...message });
                    } else {
                        message.father_occupation = '';
                        setMessage({ ...message });
                    }
                }
            }
            // father salary
            // if (data.recommendation_id != 6) {
            //     if (data.father_salary == '') {
            //         message.father_salary = 'Father Salary is required';
            //         setMessage({ ...message });
            //     } else {
            //         let checkregex = OnlyNumberAlphabetSpace(data.father_salary);
            //         if (checkregex) {
            //             message.father_salary = 'Valid CTC is required';
            //             setMessage({ ...message });
            //         } else {
            //             message.father_salary = '';
            //             setMessage({ ...message });
            //         }
            //     }
            // }
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.father_salary == '') {
                    message.father_salary = 'Father Salary is required';
                    setMessage({ ...message });
                } else if (data.father_salary.toUpperCase() !== 'NA' && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                    let checkregex = OnlyNumberAlphabetSpace(data.father_salary);
                    if (checkregex) {
                        message.father_salary = 'Valid CTC is required';
                        setMessage({ ...message });
                    } else {
                        message.father_salary = '';
                        setMessage({ ...message });
                    }
                } else {
                    message.father_salary = '';
                    setMessage({ ...message });
                }
            }
            //mother occ
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.mother_occupation == '') {
                    message.mother_occupation = 'Mother Occupation is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.mother_occupation);
                    if (checkregex) {
                        message.mother_occupation = 'Valid Mother Occupation is required';
                        setMessage({ ...message });
                    } else {
                        message.mother_occupation = '';
                        setMessage({ ...message });
                    }
                }
            }
            //Mother salary
            // if (data.recommendation_id != 6) {
            //     if (data.mother_salary == '') {
            //         message.mother_salary = 'Mother Salary is required';
            //         setMessage({ ...message });
            //     } else {
            //         let checkregex = OnlyNumberAlphabetSpace(data.mother_salary);
            //         if (checkregex) {
            //             message.mother_salary = 'Valid CTC is required';
            //             setMessage({ ...message });
            //         } else {
            //             message.mother_salary = '';
            //             setMessage({ ...message });
            //         }
            //     }
            // }
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.mother_salary == '') {
                    message.mother_salary = 'Mother Salary is required';
                    setMessage({ ...message });
                } else if (data.mother_salary.toUpperCase() !== 'NA' && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                    let checkregex = OnlyNumberAlphabetSpace(data.mother_salary);
                    if (checkregex) {
                        message.mother_salary = 'Valid CTC is required';
                        setMessage({ ...message });
                    } else {
                        message.mother_salary = '';
                        setMessage({ ...message });
                    }
                } else {
                    message.mother_salary = '';
                    setMessage({ ...message });
                }
            }
            //sibling details
            let siblingError = false
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                siblingError = false;
                data.siblings.forEach((sibling, index) => {
                    // Occupation validation
                    if (sibling.occupation.trim() !== '') {
                        let checkOccupation = OnlyNumberAndSpecialChar(sibling.occupation);
                        if (checkOccupation) {
                            message[`sibling_occupation_${index}`] = 'Invalid occupation format';
                            siblingError = true;
                        } else {
                            message[`sibling_occupation_${index}`] = '';
                        }
                    } else {
                        message[`sibling_occupation_${index}`] = '';
                    }

                    // Salary validation
                    if (sibling.salary.trim() !== '') {
                        if (sibling.salary.toUpperCase() !== 'NA') {
                            let checkSalary = OnlyNumberAlphabetSpace(sibling.salary);
                            if (checkSalary) {
                                message[`sibling_salary_${index}`] = 'Valid CTC is required';
                                siblingError = true;
                            } else {
                                message[`sibling_salary_${index}`] = '';
                            }
                        } else {
                            message[`sibling_salary_${index}`] = '';
                        }
                    } else {
                        message[`sibling_salary_${index}`] = '';
                    }
                });

                if (siblingError) {
                    setMessage({ ...message });
                    // return;
                }
            }
            //overall CTC
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.ctc == '') {
                    message.ctc = 'CTC is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAlphabetSpace(data.ctc);
                    if (checkregex) {
                        message.ctc = 'Valid CTC is required';
                        setMessage({ ...message });
                    } else {
                        message.ctc = '';
                        setMessage({ ...message });
                    }
                }
            }
            // Domain selection
            if (data.recommendation_id != 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'Avasoft Final Meeting') {
                if (data.domain == '') {
                    message.domain = 'Domain is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.domain);
                    if (checkregex) {
                        message.domain = 'Valid Domain is required';
                        setMessage({ ...message });
                    } else {
                        message.domain = '';
                        setMessage({ ...message });
                    }
                }
            }
            // if (val !== 'Group Discussion' && val !== 'Technical Discussion' && val !== 'HR Discussion') {
            //reason for reschedule
            if (data.recommendation_id == 6) {
                if (data.reason_for_reschedule == '') {
                    message.reason_for_reschedule = 'reason_for_reschedule is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.reason_for_reschedule);
                    if (checkregex) {
                        message.reason_for_reschedule = 'Valid reason_for_reschedule is required';
                        setMessage({ ...message });
                    } else {
                        message.reason_for_reschedule = '';
                        setMessage({ ...message });
                    }
                }
            }
            //}
            //PC_FB_18 -> condition for overAllComments is checked for emtpy string

            if (data.recommendation_id != 6) {
                if (data.overAllComments == '') {
                    message.overAllComments = 'Overall comments is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.overAllComments);
                    if (checkregex) {
                        message.overAllComments = 'Valid Overall comments is required';
                        setMessage({ ...message });
                    } else {
                        message.overAllComments = '';
                        setMessage({ ...message });
                    }
                }
            }
            isValid = data.recommendation_id !== '' && data.recommendation_id !== undefined;

            if (data.recommendation_id == 6) {
                // For Reschedule, only reason_for_reschedule is required
                isValid = isValid && data.reason_for_reschedule !== '';
            } else if (data.recommendation_id != 6) {
                // For other statuses, check all required fields
                if (scheduledInterviewData.stage !== 'Group Discussion') {
                    isValid = isValid &&
                        data.attitude !== '' &&
                        data.communication !== '' &&
                        data.business !== '' &&
                        data.technology !== '' &&
                        data.overAllComments !== '';

                    // Add validation for family details if it's Technical Discussion
                    if (scheduledInterviewData.stage === 'Technical Discussion') {
                        isValid = isValid &&
                            data.father_occupation !== '' &&
                            data.father_salary !== '' &&
                            data.mother_occupation !== '' &&
                            data.mother_salary !== '' &&
                            data.current_location !== '' &&
                            data.native_location !== '' &&
                            data.ctc !== '' &&
                            data.domain !== '';
                    }

                    // Add validation for CTC and domain for HR Discussion and Avasoft Final Round
                    if (scheduledInterviewData.stage === 'HR Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round') {
                        isValid = isValid &&
                            data.ctc !== '' &&
                            data.domain !== '';
                    }
                }
            }

            // isValid = data.recommendation_id !== '' && data.recommendation_id !== undefined &&
            // ((data.recommendation_id == 6 && data.reason_for_reschedule !== '') ||
            // (data.recommendation_id != 6 &&
            // (data.attitude !== '' &&
            // data.communication !== '' &&
            // data.business !== '' &&
            // data.technology !== '' &&
            // data.overAllComments !== '')));

            // // Add validation for family details
            // if (data.recommendation_id != 6) {
            //     isValid = isValid && data.father_occupation !== '' &&
            //               data.father_salary !== '' &&
            //               data.mother_occupation !== '' &&
            //               data.mother_salary !== '' &&
            //               data.current_location !== '' &&
            //               data.native_location !== '';
            // }
            // if (data.recommendation_id != 6) {
            //     isValid = isValid && data.ctc !== '' && !OnlyNumberAlphabetSpace(data.ctc) && data.domain !== '';
            // }
            if ((message.attitude !== 'Attitude is required' && message.attitude !== 'Valid attitude is required') &&
                (message.communication !== 'Communication is required' && message.communication !== 'Valid communication is required') &&
                (message.business !== 'Business is required' && message.business !== 'Valid business is required') &&
                (message.technology !== 'Technology is required' && message.technology !== 'Valid technology is required') &&
                (message.overAllComments !== 'Overall comments is required' && message.overAllComments !== 'Valid Overall comments is required') &&
                (message.ctc !== 'CTC is required' && message.ctc !== 'Valid CTC is required') &&
                (message.domain !== 'Domain is required' && message.domain !== 'Valid Domain is required') &&
                (message.current_location !== 'Current District is required' && message.current_location !== 'Valid Current District is required') &&
                (message.native_location !== 'Native District is required' && message.native_location !== 'Valid Native District is required') &&
                (message.father_occupation !== 'Father Occupation is required' && message.father_occupation !== 'Valid Father Occupation is required') &&
                (message.father_salary !== 'Father Salary is required' && message.father_salary !== 'Valid CTC is required') &&
                (message.mother_occupation !== 'Mother Occupation is required' && message.mother_occupation !== 'Valid Mother Occupation is required') &&
                (message.mother_salary !== 'Mother Salary is required' && message.mother_salary !== 'Valid CTC is required') &&
                message.siblings.every(sibling => sibling.occupation !== 'Invalid occupation format' && sibling.salary !== 'Valid CTC is required') && !siblingError) {
                if (isValid) {


                    //PC_FB_19 -> the Api function is called and stored in UpdateResponse

                    setIsLoadingLoader(false);
                    data['emp_id'] = encryptStorage.getItem('employeeId');

                    let interviewId = data.interview_id;
                    let round = await getInterviewRoundName({
                        id: interviewId,
                        job_id: new URLSearchParams(search).get('jId'),
                    });
                    if (AddFeedBack.is_check == true) {
                        if (data.recommendation_id == 1) {
                            if (round.data.data[0].interview_round_name == 'Avasoft Final Round') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you for taking time to participate in the Avasoft Final Round. We are pleased to inform you that you have been selected in the final phase of evaluation. You will be having the HR round with our HR Manager. You will be notified on the interview details shortly<br/> <br/>
                                Wishing you Best of Luck !<br/><br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else if (round.data.data[0].interview_round_name == 'Technical Discussion') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you for taking time to participate in the Technical Discussion. We are pleased to inform you that you have been shortlisted for the further rounds. You will be notified on the interview details shortly. <br/><br/>
                                Wishing you Best of Luck ! <br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else if (round.data.data[0].interview_round_name == 'HR Discussion') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you for taking time to participate in the HR Discussion. We are pleased to inform you that you have been shortlisted for the Final phase of evaluation.You will be having a Final Meeting to discuss the terms and condition post which you will be receiving your offer letter. <br/><br/>
                                Wishing you Best of Luck ! <br/><br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you for taking time to participate in the ${round.data.data[0].interview_round_name}. We are pleased to inform you that you have been shortlisted for the next phase of evaluation.  <br/><br/>
                                Wishing you Best of Luck ! <br/><br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            }

                            // sendMail({
                            //     data: 'You are Selected https://hivecandidate.avasoft.com/InterviewStatus',
                            // });
                        } else if (data.recommendation_id == 2) {
                            if (round.data.data[0].interview_round_name == 'Avasoft Final Round') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application and interview's feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.
                              Hope our paths cross again!  <br/><br/>
                              Thanks again for the time and effort you have invested in the interview process with us.  <br/><br/>
    
                              AVASOFT wishes you All the very best on your Job search! <br/><br/>
                              Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else if (round.data.data[0].interview_round_name == 'Technical Discussion') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you so much for your interest in working with AVASOFT!
                              It was a pleasure to learn more about your skills and accomplishments.
                              We reviewed your application, Preliminary response, first level of Evaluation and Technical interview's
                              feedback at multiple levels and after careful consideration, unfortunately our team did not
                              select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application
                              in the future (in 6 months), do let us know what new skills you have scaled up since your last application. <br/> <br/>
                              Hope our paths cross again!  <br/><br/>
                              Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>
    
                              AVASOFT wishes you All the very best on your Job search!<br/><br/>
                              Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else if (round.data.data[0].interview_round_name == 'HR Discussion') {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application, Preliminary response, first level of Evaluation, Technical and HR interview's feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.Hope our paths cross again!  <br/>
                                Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>
                                AVASOFT wishes you All the very best on your Job search! <br/><br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            } else {
                                let content = {
                                    Subject: `AVASOFT-Interview Results`,
                                    body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
    
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                                </div>
                               </div>
    
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Dear Candidate,
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application, Preliminary response and first level of Evaluation feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.Hope our paths cross again!  <br/>
                                Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>
                                AVASOFT wishes you All the very best on your Job search! <br/><br/>
                                Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
    
                            </div>
                            </body>
                            </html>`,
                                    to: [props.email],
                                };
                                sendMail(content);
                            }
                        }
                    }
                    if (data.recommendation_id == 2) {
                        let obj = { status: 'Rejected', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    else if (data.recommendation_id == 1) {
                        let obj = { status: 'Selected', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    else if (data.recommendation_id == 3) {
                        let obj = { status: 'On Hold', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    else if (data.recommendation_id == 4) {
                        let obj = { status: 'Delegate', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    else if (data.recommendation_id == 5) {
                        let obj = { status: 'No Show', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    else if (data.recommendation_id == 6) {
                        let obj = { status: 'Reschedule', id: [props.candidate_id] };
                        let postStatus;
                        if (props.experience == 'Fresher') {
                            postStatus = await updateFresherStatus(obj);
                        }
                        else {
                            postStatus = await updateExpStatus(obj);

                        }
                    }
                    // else if(data.recommendation_id == 6){
                    //     let obj = { status: 'Reschedule', id: [props.candidate_id] };
                    //      postStatus = await updateFresherStatus(obj);
                    // }


                    let updateResponse = await sendFeedback(data);
                    //PC_FB_23 -> updateResponse is checked and set stated
                    if (updateResponse.data.statusCode == 200) {
                        setIsLoadingLoader(true);
                        setFeedBackDisabled(true);
                        setUpdateButton('Edit');
                        if (data.recommendation_id == 1 && round.data.data[0].interview_round_name == 'Avasoft Final Meeting') {
                            if (encryptStorage.getItem('recruitRole') !== 'Panel Member') {
                                navigate('/OfferLetter?id=' + props.candidate_id + '&exp=' + props.experience + '&round=mwc&jid=' + props.jobId);
                            }
                        }
                        setRenderFlag(!renderFlag);
                    } else {
                        setRenderFlag(!renderFlag);
                    }
                }
            }
        }
    };

    let bind = async () => {
        try {
            let empResult1 = [];

            let empResult = await directory({});
            let samplearray = [];
            let loginEmail = await getLoginEmailId({ emp_id: encryptStorage.getItem('employeeId') });

            let email = loginEmail.data.data[0].email_id;

            let temparray = empResult.data?.ResponseData.emplist;

            for (let i = 0; i <= temparray.length - 1; i++) {
                let objresponse = {
                    value: temparray[i].emp_id,
                    email_id: temparray[i].email_id,

                    img: '/Images/logo-person-user-person-icon.jpg',
                    label: temparray[i].emp_name,
                    username: temparray[i].emp_name,
                };

                samplearray.push(objresponse);
            }
            setShowEmployee(samplearray);

            let objresponse = {
                value: UserId,
                img: '/Images/logo-person-user-person-icon.jpg',
                label: UserName,
                username: UserName,
                email_id: email,
            };

            let arr = [];
            arr.push(objresponse);

            setSelectedPeopleList(arr);

            let newObj = {
                value: props.candidate_id,
                label: props.email,
                username: props.email,
            };
            setSelectedCandidate(newObj);
            empResult1.push(newObj);
            setShowCandidate(empResult1);
        } catch (e) {
            throw e;
        }
    };

    let minDate = moment(new Date()).format('L');
    minDate = minDate.split('/')[2] + '-' + minDate.split('/')[0] + '-' + minDate.split('/')[1];

    let deleteInterviewClick = async () => {
        let resp = await deleteScheduledInterview({
            id: deleteInterviewIndex,
            experience: props.experience,
        });
        if (resp.data.statusCode == 200) {
            setRenderFlag(!renderFlag);
        }
    };
    /**
     * 
     * PS_PD_10 - PS_PD_36 - On click of the submit button, we'll validate Family details and location details
     *                        and we are going to sent a details to backend with the help of sendFeedback(Data)
     * PS_RE_07 - PS_RE_15 - On click of the submit button, we'll validate Reason for reschedule detail
     *                        and we are going to sent a detail to backend with the help of sendFeedback(Data)
     */

    let submitFeedBack = async (val) => {

        let isValid = true;
        let data = AddFeedBack;

        // if (scheduledInterviewData.stage === 'Group Discussion') {
        //     // Validate and prepare data for Group Discussion
        //     if (AddFeedBack.overAllComments.trim() === '') {
        //         message.overAllComments = 'Overall comments is required';
        //         setMessage({ ...message });
        //         return;
        //     }

        //     let data = {
        //         ...AddFeedBack,
        //         overall_comments: AddFeedBack.overAllComments,
        //         // Add other necessary fields
        //     };
        //     let resp = await sendFeedback(data);
        // }

        if (data.recommendation_id == '' || data.recommendation_id == undefined) {
            message.status = 'Status is required';
            setMessage({ ...message });
        } else {
            message.status = '';
            setMessage({ ...message });
        }
        if (data.recommendation_id != 6) {
            if (val !== 'Group Discussion') {
                if (data.attitude == '') {
                    message.attitude = 'Attitude is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.attitude);
                    if (checkregex) {
                        message.attitude = 'Valid attitude is required';
                        setMessage({ ...message });
                    } else {
                        message.attitude = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val !== 'Group Discussion') {
                if (data.communication == '') {
                    message.communication = 'Communication is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.communication);
                    if (checkregex) {
                        message.communication = 'Valid communication is required';
                        setMessage({ ...message });
                    } else {
                        message.communication = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val !== 'Group Discussion') {
                if (data.business == '') {
                    message.business = 'Business is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.business);
                    if (checkregex) {
                        message.business = 'Valid business is required';
                        setMessage({ ...message });
                    } else {
                        message.business = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val !== 'Group Discussion') {
                if (data.technology == '') {
                    message.technology = 'Technology is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.technology);
                    if (checkregex) {
                        message.technology = 'Valid technology is required';
                        setMessage({ ...message });
                    } else {
                        message.technology = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.father_occupation == '') {
                    message.father_occupation = 'Father Occupation is required';
                    setMessage({ ...message });
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.father_occupation);
                    if (checkregex) {
                        message.father_occupation = 'Valid Father Occupation is required';
                        setMessage({ ...message });
                    } else {
                        message.father_occupation = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.father_salary == '') {
                    message.father_salary = 'Father Salary is required';
                    setMessage({ ...message });
                } else if (data.father_salary.toUpperCase() !== 'NA') {
                    let checkregex = OnlyNumberAlphabetSpace(data.father_salary);
                    if (checkregex) {
                        message.father_salary = 'Valid CTC is required';
                        setMessage({ ...message });
                    } else {
                        message.father_salary = '';
                        setMessage({ ...message });
                    }
                }
                else {
                    message.father_salary = '';
                    setMessage({ ...message });
                }
            }
        }

        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.mother_occupation == '') {
                    message.mother_occupation = 'Mother Occupation is required';
                    setMessage({ ...message });
                    isValid = false;

                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.mother_occupation);
                    if (checkregex) {
                        message.mother_occupation = 'Valid Mother Occupation is required';
                        setMessage({ ...message });
                        isValid = false;

                    } else {
                        message.mother_occupation = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.mother_salary == '') {
                    message.mother_salary = 'Mother Salary is required';
                    setMessage({ ...message });
                } else if (data.mother_salary.toUpperCase() !== 'NA') {
                    let checkregex = OnlyNumberAlphabetSpace(data.mother_salary);
                    if (checkregex) {
                        message.mother_salary = 'Valid CTC is required';
                        setMessage({ ...message });
                    } else {
                        message.mother_salary = '';
                        setMessage({ ...message });
                    }
                }
                else {
                    message.mother_salary = '';
                    setMessage({ ...message });
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                let siblingError = false;
                data.siblings.forEach((sibling, index) => {
                    // Occupation validation
                    if (sibling.occupation.trim() !== '') {
                        let checkOccupation = OnlyNumberAndSpecialChar(sibling.occupation);
                        if (checkOccupation) {
                            message[`sibling_occupation_${index}`] = 'Invalid occupation format';
                            siblingError = true;
                        } else {
                            message[`sibling_occupation_${index}`] = '';
                        }
                    } else {
                        message[`sibling_occupation_${index}`] = '';
                    }

                    // Salary validation
                    if (sibling.salary.trim() !== '') {
                        if (sibling.salary.toUpperCase() !== 'NA') {
                            let checkSalary = OnlyNumberAlphabetSpace(sibling.salary);
                            if (checkSalary) {
                                message[`sibling_salary_${index}`] = 'Valid CTC is required';
                                siblingError = true;
                            } else {
                                message[`sibling_salary_${index}`] = '';
                            }
                        } else {
                            message[`sibling_salary_${index}`] = '';
                        }
                    } else {
                        message[`sibling_salary_${index}`] = '';
                    }
                });

                if (siblingError) {
                    setMessage({ ...message });
                    // return;
                }
            }
        }
        if (data.recommendation_id != 2 && data.recommendation_id != 6 && (val === 'Technical Discussion' || val === 'HR Discussion' || val === 'Avasoft Final Round')) {
            if (data.ctc == '') {
                message.ctc = 'CTC is required';
                setMessage({ ...message });
                isValid = false;
            } else {
                let checkregex = OnlyNumberAlphabetSpace(data.ctc);
                if (checkregex) {
                    message.ctc = 'Valid CTC is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    message.ctc = '';
                    setMessage({ ...message });
                }
            }

            // Similarly, for domain
            if (data.domain == '') {
                message.domain = 'Domain is required';
                setMessage({ ...message });
                isValid = false;
            } else {
                let checkregex = OnlyNumberAndSpecialChar(data.domain);
                if (checkregex) {
                    message.domain = 'Valid Domain is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    message.domain = '';
                    setMessage({ ...message });
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.current_location == '') {
                    message.current_location = 'Current District is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.current_location);
                    if (checkregex) {
                        message.current_location = 'Valid Current District is required';
                        setMessage({ ...message });
                        isValid = false;
                    } else {
                        message.current_location = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (val === 'Technical Discussion') {
                if (data.native_location == '') {
                    message.native_location = 'Native District is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    let checkregex = OnlyNumberAndSpecialChar(data.native_location);
                    if (checkregex) {
                        message.native_location = 'Valid Native District is required';
                        setMessage({ ...message });
                        isValid = false;
                    } else {
                        message.native_location = '';
                        setMessage({ ...message });
                    }
                }
            }
        }
        //if (val !== 'Group Discussion' && val !== 'Technical Discussion' && val !== 'HR Discussion') {
        if (data.recommendation_id == 6) {
            if (data.reason_for_reschedule == '') {
                message.reason_for_reschedule = 'Reason for Reschedule is required';
                setMessage({ ...message });
                isValid = false;
            } else {
                let checkregex = OnlyNumberAndSpecialChar(data.reason_for_reschedule);
                if (checkregex) {
                    message.reason_for_reschedule = 'Valid reason for reschedule is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    message.reason_for_reschedule = '';
                    setMessage({ ...message });
                }
            }
        }
        if (data.recommendation_id != 6) {
            if (data.overAllComments == '') {
                message.overAllComments = 'Overall comments is required';
                setMessage({ ...message });
                isValid = false;
            } else {
                let checkregex = OnlyNumberAndSpecialChar(data.overAllComments);
                if (checkregex) {
                    message.overAllComments = 'Valid Overall comments is required';
                    setMessage({ ...message });
                    isValid = false;
                } else {
                    message.overAllComments = '';
                    setMessage({ ...message });
                }
            }
        }
        isValid = data.recommendation_id !== '' && data.recommendation_id !== undefined &&
            ((data.recommendation_id == 6 && data.reason_for_reschedule !== '') ||
                (data.recommendation_id != 6 &&
                    ((val == 'Group Discussion') || (data.attitude !== '' &&
                        data.communication !== '' &&
                        data.business !== '' &&
                        data.technology !== '' &&
                        data.overAllComments !== ''))));

        // Add validation for family details
        if (val === 'Technical Discussion' && data.recommendation_id != 6) {
            isValid = isValid && data.father_occupation !== '' &&
                data.father_salary !== '' &&
                data.mother_occupation !== '' &&
                data.mother_salary !== '' &&
                data.current_location !== '' &&
                data.native_location !== '';
        }
        if ((val === 'Avasoft Final Round' || val === 'HR Discussion' || val === 'Technical Discussion') && data.recommendation_id != 6 && data.recommendation_id != 2) {
            isValid = isValid && data.ctc !== '' && data.domain !== '';
        }

        if ((message.attitude !== 'Attitude is required' && message.attitude !== 'Valid attitude is required') &&
            (message.communication !== 'Communication is required' && message.communication !== 'Valid communication is required') &&
            (message.business !== 'Business is required' && message.business !== 'Valid business is required') &&
            (message.technology !== 'Technology is required' && message.technology !== 'Valid technology is required') &&
            (message.overAllComments !== 'Overall comments is required' && message.overAllComments !== 'Valid Overall comments is required') &&
            (message.ctc !== 'CTC is required' && message.ctc !== 'Valid CTC is required') &&
            (message.domain !== 'Domain is required' && message.domain !== 'Valid Domain is required') &&
            (message.current_location !== 'Current District is required' && message.current_location !== 'Valid Current District is required') &&
            (message.native_location !== 'Native District is required' && message.native_location !== 'Valid Native District is required') &&
            (message.father_occupation !== 'Father Occupation is required' && message.father_occupation !== 'Valid Father Occupation is required') &&
            (message.father_salary !== 'Father Salary is required' && message.father_salary !== 'Valid CTC is required') &&
            (message.mother_occupation !== 'Mother Occupation is required' && message.mother_occupation !== 'Valid Mother Occupation is required') &&
            (message.mother_salary !== 'Mother Salary is required' && message.mother_salary !== 'Valid CTC is required') &&
            message.siblings.every(sibling => sibling.occupation !== 'Invalid occupation format' && sibling.salary !== 'Valid CTC is required')) {

            if (isValid) {
                setIsLoadingLoader(false);

                let interviewId = data.interview_id;
                let round = await getInterviewRoundName({
                    id: interviewId,
                    job_id: new URLSearchParams(search).get('jId'),
                });

                data['experience'] = props.experience;
                data['candidate_id'] = props.candidate_id;

                if (val === 'Technical Discussion' && data.recommendation_id != 6) {
                    data['father_occupation'] = AddFeedBack.father_occupation;
                    data['father_salary'] = AddFeedBack.father_salary;
                    data['mother_occupation'] = AddFeedBack.mother_occupation;
                    data['mother_salary'] = AddFeedBack.mother_salary;
                }
                //PS_CB_08-18
                if (AddFeedBack.is_check == true) {

                    if (data.recommendation_id == 1) {
                        if (round.data.data[0].interview_round_name == 'Avasoft Final Round') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you for taking time to participate in the Avasoft Final Round. We are pleased to inform you that you have been selected in the final phase of evaluation. You will be having the HR round with our HR Manager. You will be notified on the interview details shortly.<br/> <br/>
                            Wishing you Best of Luck !<br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else if (round.data.data[0].interview_round_name == 'Technical Discussion') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you for taking time to participate in the Technical Discussion. We are pleased to inform you that you have been shortlisted for the further rounds. You will be notified on the interview details shortly. <br/><br/>
                            Wishing you Best of Luck ! <br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else if (round.data.data[0].interview_round_name == 'HR Discussion') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you for taking time to participate in the HR Discussion. We are pleased to inform you that you have been shortlisted for the Final phase of evaluation. You will be having a Final Meeting to discuss the terms and condition post which you will be receiving your offer letter. <br/><br/>
                            Wishing you Best of Luck ! <br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you for taking time to participate in the ${round.data.data[0].interview_round_name}. We are pleased to inform you that you have been shortlisted for the next phase of evaluation.  <br/><br/>
                            Wishing you Best of Luck ! <br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        }

                        // sendMail({
                        //     data: 'You are Selected https://hivecandidate.avasoft.com/InterviewStatus',
                        // });
                    } else if (data.recommendation_id == 2) {
                        if (round.data.data[0].interview_round_name == 'Avasoft Final Round') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application and interview's feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.
                          Hope our paths cross again!  <br/><br/>
                          Thanks again for the time and effort you have invested in the interview process with us.  <br/><br/>

                          AVASOFT wishes you All the very best on your Job search! <br/><br/>
                          Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else if (round.data.data[0].interview_round_name == 'Technical Discussion') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you so much for your interest in working with AVASOFT!
                          It was a pleasure to learn more about your skills and accomplishments.
                          We reviewed your application, Preliminary response, first level of Evaluation and Technical interview's
                          feedback at multiple levels and after careful consideration, unfortunately our team did not
                          select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application
                          in the future (in 6 months), do let us know what new skills you have scaled up since your last application. <br/> <br/>
                          Hope our paths cross again!  <br/><br/>
                          Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>

                          AVASOFT wishes you All the very best on your Job search!<br/><br/>
                          Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else if (round.data.data[0].interview_round_name == 'HR Discussion') {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application, Preliminary response, first level of Evaluation, Technical and HR interview's feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.Hope our paths cross again!  <br/>
                            Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>
                            AVASOFT wishes you All the very best on your Job search! <br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        } else {
                            let content = {
                                Subject: `AVASOFT-Interview Results`,
                                body: `<html lang="en">

                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>

                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2024/05/Avasoft-logo-30-05.svg" alt="logo" style="width: 120px;">
                            </div>
                           </div>

                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Thank you so much for your interest in working with AVASOFT! It was a pleasure to learn more about your skills and accomplishments. We reviewed your application, Preliminary response and first level of Evaluation feedback at multiple levels and after careful consideration, unfortunately our team did not select you for further consideration as we couldn't see a fit for you at this point. Should you like us to re-assess your application in the future (in 6 months), do let us know what new skills you have scaled up since your last application.Hope our paths cross again!  <br/>
                            Thanks again for the time and effort you have invested in the interview process with us.<br/>  <br/>
                            AVASOFT wishes you All the very best on your Job search! <br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}"> https://hivecandidate.avasoft.com?id=${props.jobId}</a>
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>

                        </div>
                        </body>
                        </html>`,
                                to: [props.email],
                            };
                            sendMail(content);
                        }
                    }
                }
                let postStatus

                // if (data.recommendation_id == 2) {
                //     let obj = { status: 'Rejected', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                // else if(data.recommendation_id == 1){
                //     let obj = { status: 'Selected', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                // else if(data.recommendation_id == 3){
                //     let obj = { status: 'On Hold', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                // else if(data.recommendation_id == 4){
                //     let obj = { status: 'Delegate', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                // else if(data.recommendation_id == 5){
                //     let obj = { status: 'No Show', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                // else if(data.recommendation_id == 6){
                //     let obj = { status: 'Reschedule', id: [props.candidate_id] };
                //      postStatus = await updateFresherStatus(obj);
                // }
                if (data.recommendation_id >= 1 && data.recommendation_id <= 6) {
                    const statusMapping = {
                        1: 'Selected',
                        2: 'Rejected',
                        3: 'On Hold',
                        4: 'Delegate',
                        5: 'No Show',
                        6: 'Reschedule'
                    };
                    let obj = { status: statusMapping[data.recommendation_id], id: [props.candidate_id] };
                    if (props.experience == 'Fresher') {
                        postStatus = await updateFresherStatus(obj);
                    }
                    else {
                        postStatus = await updateExpStatus(obj);
                    }
                }
                let reason = `Interview feedback submitted for  ${JobTitle}- ${val} stage  by ${UserName}`;
                let payload = {
                    icon_category: 'Feedback',
                    candidateType: props.experience,
                    audit_reason: reason,
                    candidate_id: props.candidate_id,
                    job_id: job_id,
                };

                let response1 = await postTimeline(payload);
                data['emp_id'] = encryptStorage.getItem('employeeId');

                let resp = await sendFeedback(data);
                setShowFeedback(false);
                if (resp.data.statusCode == 200) {
                    setIsLoadingLoader(true);
                    setInterviewData({
                        title: '',
                        meeting_details: '',
                        interview_round_id: '',
                        interview_date: '',
                        start_time: '',
                        end_time: '',
                    });
                    setTitleValidation('');
                    setMeetingDetailsValidation('');
                    setInterviewRoundValidation('');
                    setInterviewersValidation('');
                    setCandidatesValidation('');
                    setDateValidation('');
                    setStartTimeValidation('');
                    setEndTimeValidation('');
                    setShowContainer(false);
                    cancelClick();
                    // if (data.recommendation_id == 1 && round.data.data[0].interview_round_name == 'Avasoft Final Round') {
                    //     if (encryptStorage.getItem('recruitRole') !== 'Panel Member') {
                    //         navigate('/OfferLetter?id=' + props.candidate_id + '&exp=' + props.experience + '&round=fr&jid=' + props.jobId);
                    //     }
                    // }
                    if (data.recommendation_id == 1 && round.data.data[0].interview_round_name == 'Avasoft Final Meeting') {
                        if (encryptStorage.getItem('recruitRole') !== 'Panel Member') {
                            navigate('/OfferLetter?id=' + props.candidate_id + '&exp=' + props.experience + '&round=mwc&jid=' + props.jobId);
                        }
                    }
                    setRenderFlag(!renderFlag);
                }
            }
        }
    };
    // let bindComments = () => {
    //     return feedbackView.map((value, index) => {
    //         return (
    //             <>
    //                 <h6 className="font-16 semibold-text secheader-fb-clr ">
    //                     {value.round_assessment_id == 1 ? (
    //                         'Attitude'
    //                     ) : value.round_assessment_id == 2 ? (
    //                         'Communication'
    //                     ) : value.round_assessment_id == 3 ? (
    //                         'Business'
    //                     ) : value.round_assessment_id == 4 ? (
    //                         'Technology'
    //                     ) : (
    //                         <></>
    //                     )}
    //                 </h6>
    //                 <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{value.comments}</p>
    //             </>
    //         );
    //     });
    // };

    //loop is iterated for range of length of feedbackView in the function bindPreviousComments
    let bindPreviousComments = () => {

        let gd_feedbck = feedbackView.gd_feedback;
        let feedbackGrouped;
        gd_feedbck
            ? (feedbackGrouped = Array.from({ length: Math.ceil(gd_feedbck.length / 1) }, (_, index) =>
                gd_feedbck.slice(index * 1, index * 1 + 1)
            ))
            : (feedbackGrouped = Array.from({ length: Math.ceil(feedbackView.length / 4) }, (_, index) =>
                feedbackView.slice(index * 4, index * 4 + 4)
            ));

        // let FormFeedbackData = feedbackGrouped[feedbackGrouped.length - 1];

        return feedbackGrouped.slice(0, feedbackGrouped.length - 1).map((val, index) => {

            return feedbackGrouped[index].map((value, i) => {
                return (
                    <>
                        <div className="cus-data-sty px-3 py-3">
                            {i == 0 ? (
                                <h5 className="bold-text font-18 prmheader-fb-clr mb-3">
                                    Previous Comments - {val[i]?.emp_name}
                                </h5>
                            ) : (
                                <></>
                            )}
                            <h6 className="font-16 semibold-text secheader-fb-clr ">
                                {value?.round_assessment_id == 1 ? (
                                    'Attitude'
                                ) : value?.round_assessment_id == 2 ? (
                                    'Communication'
                                ) : value?.round_assessment_id == 3 ? (
                                    'Business'
                                ) : value?.round_assessment_id == 4 ? (
                                    'Technology'
                                ) : (
                                    <></>
                                )}
                            </h6>
                            <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{value?.comments}</p>

                            {i == 3 || (gd_feedbck ? i == 0 : false) ? (
                                <>
                                    <h6 className="font-16 semibold-text secheader-fb-clr ">Overall commments</h6>
                                    <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{val[i]?.overall_comments}</p>
                                    {val[i]?.overall_recommendation_id == 6 && (
                                        <>
                                            <h6 className="font-16 semibold-text secheader-fb-clr ">Reason for Rescheduling</h6>
                                            <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{val[i]?.reason_for_reschedule}</p>
                                        </>
                                    )}
                                    {/* Family Details */}
                                    {val[i]?.father_occupation && (
                                        <div>
                                            <h6 className="font-16 semibold-text secheader-fb-clr">Family Details</h6>
                                            <p>Father's Occupation: {val[i]?.father_occupation}</p>
                                            <p>Father's Salary: {val[i]?.father_salary}</p>
                                            <p>Mother's Occupation: {val[i]?.mother_occupation}</p>
                                            <p>Mother's Salary: {val[i]?.mother_salary}</p>
                                            {val[i]?.siblings.map((sibling, index) => (
                                                <div key={index}>
                                                    <p>Sibling {index + 1} Occupation: {sibling.sibling_occupation || 'N/A'}</p>
                                                    <p>Sibling {index + 1} Salary: {sibling.sibling_salary || 'N/A'}</p>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Location Details */}
                                    {val[i]?.current_location && (
                                        <div>
                                            <h6 className="font-16 semibold-text secheader-fb-clr">Location Details</h6>
                                            <p>Current Location: {val[i]?.current_location}</p>
                                            <p>Native Location: {val[i]?.native_location}</p>
                                        </div>
                                    )}

                                    {/* Other Details */}
                                    {val[i]?.ctc && (
                                        <div>
                                            <h6 className="font-16 semibold-text secheader-fb-clr">Other Details</h6>
                                            <p>CTC: {val[i]?.ctc}</p>
                                            <p>Domain: {val[i]?.domain}</p>
                                        </div>
                                    )}
                                    <div class="col-md-4 ">
                                        <input class="form-check-input hive-form-check-input me-2 job-posting-checkbox"
                                            type="checkbox" id="is_check"
                                            value={val[i]?.is_check}
                                            checked={val[i]?.is_check}
                                            disabled />
                                        <label class="form-check-label hive-form-check-label font-13 semibold-text" for="remote">
                                            Notify Candidate through mail</label>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}


                        </div>
                    </>
                );
            });
        });

        // for (let f = 0; f < feedbackGrouped.length; f++) {
        //     ;
        //     return(
        //     <>
        //         <h5 className="bold-text font-18 prmheader-fb-clr mb-3">Previous Comments - {feedbackGrouped[f].candidate_id}</h5>
        //         {feedbackGrouped[f].map((value, i) => {
        //                     //             return (
        //                 <>
        //                     <h6 className="font-16 semibold-text secheader-fb-clr ">
        //                         {value?.round_assessment_id == 1 ? (
        //                             'Attitude'
        //                         ) : value?.round_assessment_id == 2 ? (
        //                             'Communication'
        //                         ) : value?.round_assessment_id == 3 ? (
        //                             'Business'
        //                         ) : value?.round_assessment_id == 4 ? (
        //                             'Technology'
        //                         ) : (
        //                             <></>
        //                         )}
        //                     </h6>
        //                     <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{value?.comments}</p>
        //                 </>
        //             );
        //         })}
        //         <h6 className="font-16 semibold-text secheader-fb-clr ">Overall commments</h6>
        //         <p className="font-12 regular-text ms-3 secheader-fb-clr mb-3">{feedbackGrouped[f][f]?.overall_comments}</p>
        //     </>
        //     )

        // }
        //

        //
        // })

    };
    let editScheduledInterview = async (obj) => {
        setOffcanvasVisible(true);
        setSubmitInterviewMode('Edit');
        let resp = await getEditScheduledInterview({
            candidate_id: props.candidate_id,
            interview_id: obj.id,
            experience: props.experience,
        });
        let loginEmail = await getLoginEmailId({ emp_id: encryptStorage.getItem('employeeId') });

        let email = loginEmail.data.data[0].email_id;
        let editInterviewArray = [];
        let schedule = JSON.parse(obj.scheduled_by);
        if (Object.keys(schedule).length > 0) {
            let arr = Object.values(schedule);

            for (let i = 0; i < arr.length; i++) {
                let objresponse = {
                    value: arr[i],
                    img: '/Images/logo-person-user-person-icon.jpg',
                    label: arr[i],
                    username: arr[i],
                    email_id: email,
                };

                editInterviewArray.push(objresponse);
            }
        }

        setSelectedPeopleList(editInterviewArray);
        let editObj = {
            candidate_id: resp.data.data[0].candidate_id,
            job_id: resp.data.data[0].job_id,
            title: resp.data.data[0].title,
            meeting_details: resp.data.data[0].meeting_details,
            interview_round_id: resp.data.data[0].interview_round_id,
            interview_date: resp.data.data[0].interview_date,
            start_time: resp.data.data[0].start_time,
            end_time: resp.data.data[0].end_time,
            interviewers: UserId,
            candidates: '',
            scheduled_by: editInterviewArray,
            interview_id: resp.data.data[0].id,
            interview_round_name: resp.data.data[0].interview_round_name,
            local_start_time: resp.data.data[0].start_time,
            local_end_time: resp.data.data[0].end_time,
        };



        setInterviewData(editObj);
    };

    let bindMeetings = () => {
        try {
            if (interViews?.length == 0 || interViews[0] == undefined) {
                return (
                    <div className="row justify-content-center">
                        <img
                            src="/Images/nodatafound.png"
                            alt="nodatafound"
                            className="nofeedbackimg-sty"
                            style={{ height: '500px', width: '750px' }}
                        ></img>
                        <h2 className="semibold-text font-25 text-center margin-negative">No Interview's Scheduled</h2>
                    </div>
                );
            } else {
                const validInterviews = interViews.filter(obj =>
                    obj.start_time != null && obj.end_time != null && obj.interview_date != null
                );
                return validInterviews.map((obj, index) => {
                    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

                    const feedbackGroupedForm = Array.from({ length: Math.ceil(feedbackView.length / 4) }, (_, index) =>
                        feedbackView.slice(index * 4, index * 4 + 4)
                    );

                    const d = new Date(moment(obj?.interview_date).format('ll'));
                    let day = weekday[d.getDay()];
                    return (
                        <div key={index}>
                            <p className="font-16 regular-text interview-gray-color">
                                {moment(obj?.interview_date).format('ll')} ({day})
                            </p>
                            <div className="interview-card-body">
                                <div className="row align-items-center">
                                    <div className="col-md-3 my-2 interview-card-border">
                                        <p className="font-15 mb-0 p-3 regular-text interview-gray-color">
                                            <span className="bold-text d-block font-16">
                                                {moment(obj?.start_time, ['h:mm A']).format('hh:mm A')} -{' '}
                                            </span>
                                            <span className="bold-text d-block font-16">
                                                {' '}
                                                {moment(obj?.end_time, ['h:mm A']).format('hh:mm A')} - (
                                                {timeDiff(obj?.start_time, obj?.end_time)})
                                            </span>
                                        </p>
                                    </div>
                                    <div className="col-md-6 custom-col-6">
                                        <div className="d-flex mb-3 ms-2">
                                            <div className="candidate-prof-container">
                                                <img
                                                    src={imageUrls.candidate || '/Images/candidate-prof.svg'}
                                                    className="candidate-profile-icon"
                                                    alt="candidate profile"
                                                />
                                            </div>
                                            <div className="ms-3">
                                                <p className="font-16 mb-0 interview-gray-color bold-text">
                                                    {candidateName}
                                                </p>

                                                {obj?.feedback[obj?.feedback.length - 1]?.overall_comments == null ||
                                                    obj?.feedback[obj?.feedback.length - 1]?.overall_comments == undefined || obj?.feedback[obj?.feedback.length - 1]?.overall_comments == "" ? (
                                                    <>
                                                        <p className="font-16 mb-0 interview-gray-color regular-text">
                                                            Interview Scheduled
                                                        </p>
                                                    </>
                                                ) : (
                                                    <p className="font-12 mb-0 interview-gray-color regular-text">
                                                        Feedback Submitted on {moment(obj?.feedback[obj?.feedback.length - 1]?.created_at).format('ll')} @{' '}
                                                        {moment(obj?.feedback[obj?.feedback.length - 1]?.created_at).format('LT')}{' '}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <p className="font-16 mb-0 interview-gray-color ms-2">{obj?.interview_round_name}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 custom-col-3">
                                        {(() => {
                                            // First condition: Check if it's the first scheduled feedback or if there's no feedback
                                            if (obj?.feedback.length === 0 || (obj?.feedback[obj?.feedback.length - 1].status === "Scheduled" && obj?.feedback.length === 0)) {
                                                return (
                                                    <div className="d-flex align-items-center float-end mb-5 me-4">
                                                        <img
                                                            src="/Images/recruit-message.svg"
                                                            className="btn-size ms-1"
                                                            onClick={() => {
                                                                setShowFeedback(true);
                                                                setAddFeedBack((AddFeedBack) => ({
                                                                    ...AddFeedBack,
                                                                    ['interview_id']: obj.interview_round_id,
                                                                }));
                                                                setInterviewRounds(obj.interview_round_name);
                                                                setScheduledInterviewData({
                                                                    ...scheduledInterviewData,
                                                                    ['position']: JobTitle,
                                                                    ['stage']: obj.interview_round_name,
                                                                    ['Name']: candidateName,
                                                                    ['scheduled']: JSON.parse(obj.scheduled_by)[1],
                                                                    ['date']: moment(obj?.interview_date).format('ll'),
                                                                    ['duration']: timeDiff(obj?.start_time, obj?.end_time),
                                                                });
                                                            }}
                                                            title="Feedback"
                                                        />
                                                        <img
                                                            src="/Images/Edit.svg"
                                                            className="btn-size ms-1"
                                                            data-bs-toggle="offcanvas"
                                                            data-bs-target="#offcanvasRightInterview"
                                                            aria-controls="offcanvasRight"
                                                            onClick={() => {
                                                                editScheduledInterview(obj);
                                                            }}
                                                            title="Edit"
                                                        />
                                                        <img
                                                            src="/Images/recruit-delete.svg"
                                                            className="btn-size ms-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#logout"
                                                            onClick={() => {
                                                                setDeleteInterviewIndex(validInterviews[index].id);
                                                            }}
                                                            title="Delete"
                                                        />
                                                    </div>
                                                );
                                            }

                                            // If the first condition is not met, check if the latest feedback is scheduled
                                            if (obj?.feedback[obj?.feedback.length - 1].overall_recommendation_id == 6 && obj?.feedback[obj?.feedback.length - 1].status != 'Reschedule') {
                                                return (
                                                    <div className="d-flex align-items-center float-end mb-5 me-4">
                                                        <img
                                                            src="/Images/recruit-message.svg"
                                                            className="btn-size ms-1"
                                                            onClick={() => {
                                                                setShowFeedback(true);
                                                                setAddFeedBack((AddFeedBack) => ({
                                                                    ...AddFeedBack,
                                                                    ['interview_id']: obj.interview_round_id,
                                                                }));
                                                                setInterviewRounds(obj.interview_round_name);
                                                                setScheduledInterviewData({
                                                                    ...scheduledInterviewData,
                                                                    ['position']: JobTitle,
                                                                    ['stage']: obj.interview_round_name,
                                                                    ['Name']: candidateName,
                                                                    ['scheduled']: JSON.parse(obj.scheduled_by)[1],
                                                                    ['date']: moment(obj?.interview_date).format('ll'),
                                                                    ['duration']: timeDiff(obj?.start_time, obj?.end_time),
                                                                });
                                                            }}
                                                            title="Feedback"
                                                        />
                                                        <img
                                                            src="/Images/Edit.svg"
                                                            className="btn-size ms-1"
                                                            data-bs-toggle="offcanvas"
                                                            data-bs-target="#offcanvasRightInterview"
                                                            aria-controls="offcanvasRight"
                                                            onClick={() => {
                                                                editScheduledInterview(obj);
                                                            }}
                                                            title="Edit"
                                                        />
                                                        <img
                                                            src="/Images/recruit-delete.svg"
                                                            className="btn-size ms-1"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#logout"
                                                            onClick={() => {
                                                                setDeleteInterviewIndex(validInterviews[index].id);
                                                            }}
                                                            title="Delete"
                                                        />
                                                    </div>
                                                );
                                            }

                                            // If none of the above conditions are met, render the existing feedback view
                                            return (
                                                <div className="d-flex align-items-center">
                                                    <p className="font-14 mb-0 interview-gray-color regular-text me-4">
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 1 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/selected-icon.svg" alt="Select-icon" className="me-1" />
                                                                </span>
                                                                Selected
                                                            </>
                                                        )}
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 2 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/rejected-icon.svg" alt="Select-icon" className="me-1" />
                                                                </span>
                                                                Rejected
                                                            </>
                                                        )}
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 3 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/onhold-icon.svg" className="btn-size" />
                                                                </span>
                                                                On Hold
                                                            </>
                                                        )}
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 4 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/delegate-icon.svg" className="btn-size" />
                                                                </span>
                                                                Delegate
                                                            </>
                                                        )}
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 5 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/noshow-icon.svg" className="btn-size" />
                                                                </span>
                                                                No Show
                                                            </>
                                                        )}
                                                        {obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 6 && (
                                                            <>
                                                                {' '}
                                                                <span>
                                                                    <img src="/Images/Reschedule.svg" className="btn-size" />
                                                                </span>
                                                                Reschedule
                                                            </>
                                                        )}
                                                    </p>
                                                    <button
                                                        className="btn hive-btn-outline small-button font-10"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#offcanvasRightView"
                                                        aria-controls="offcanvasRightView"
                                                        onClick={() => {
                                                            viewFeedbackData = obj.assessment;
                                                            setViewFeedbackData(viewFeedbackData);
                                                            if (obj.interview_round_name == 'Group Discussion') {
                                                                setFeedbackView({ gd_feedback: obj?.feedback });
                                                            } else {
                                                                setFeedbackView(obj?.feedback);
                                                            }
                                                            setSelectedRound(obj?.feedback);
                                                            setAddFeedBack({
                                                                ...AddFeedBack,
                                                                candidate_id: obj?.feedback[0].candidate_id,
                                                                interview_id: obj.interview_round_id,
                                                                experience: props.experience,
                                                                attitude: obj?.feedback[obj?.feedback.length - 4]?.comments,
                                                                communication: obj?.feedback[obj?.feedback.length - 3]?.comments,
                                                                business: obj?.feedback[obj?.feedback.length - 2]?.comments,
                                                                technology: obj?.feedback[obj?.feedback.length - 1]?.comments,
                                                                reason_for_reschedule: obj?.feedback[obj?.feedback.length - 1]?.reason_for_reschedule || '',
                                                                father_occupation: obj?.feedback[obj?.feedback.length - 1]?.father_occupation || '',
                                                                father_salary: obj?.feedback[obj?.feedback.length - 1]?.father_salary || '',
                                                                mother_occupation: obj?.feedback[obj?.feedback.length - 1]?.mother_occupation || '',
                                                                mother_salary: obj?.feedback[obj?.feedback.length - 1]?.mother_salary || '',
                                                                current_location: obj?.feedback[obj?.feedback.length - 1]?.current_location || '',
                                                                native_location: obj?.feedback[obj?.feedback.length - 1]?.native_location || '',
                                                                ctc: obj?.feedback[obj?.feedback.length - 1]?.ctc || '',
                                                                domain: obj?.feedback[obj?.feedback.length - 1]?.domain || '',
                                                                siblings: (obj?.feedback[obj?.feedback.length - 1]?.siblings || []).map(sibling => ({
                                                                    id: sibling.id,
                                                                    occupation: sibling.sibling_occupation || '',
                                                                    salary: sibling.sibling_salary || ''
                                                                })),
                                                                overAllComments: obj?.feedback[obj?.feedback.length - 1]?.overall_comments,
                                                                is_check: obj?.feedback[obj?.feedback.length - 1]?.is_check,
                                                                recommendation_id: obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id,
                                                                statusResult:
                                                                    obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 1
                                                                        ? 'Selected'
                                                                        : obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 2
                                                                            ? 'Rejected'
                                                                            : obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 3
                                                                                ? 'On Hold'
                                                                                : obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 4
                                                                                    ? 'Delegate'
                                                                                    : obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 5
                                                                                        ? 'No Show'
                                                                                        : obj?.feedback[obj?.feedback.length - 1]?.overall_recommendation_id == 6
                                                                                            ? 'Reschedule'
                                                                                            : 'Select',
                                                            });

                                                            setScheduledInterviewData({
                                                                ...scheduledInterviewData,
                                                                ['position']: JobTitle,
                                                                ['stage']: obj.interview_round_name,
                                                                ['Name']: candidateName,
                                                                ['scheduled']: JSON.parse(obj.scheduled_by)[1],
                                                                ['date']: moment(obj?.interview_date).format('ll'),
                                                                ['duration']: timeDiff(obj?.start_time, obj?.end_time),
                                                            });
                                                        }}
                                                    >
                                                        View Feedback
                                                    </button>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                });
            }
        } catch (e) {
            console.error("Error in bindMeetings:", e);
            return null; // or some error UI
        }
    };


    let dateDifference = (startDate, endDate) => {
        if (moment(endDate).diff(moment(startDate), 'hours') != 0) {
            return moment(endDate).diff(moment(startDate), 'hours');
        } else {
            return moment(endDate).diff(moment(startDate), 'minutes');
        }
    };
    var now = moment(interviewData.start_time, 'h:mm');
    var prev = moment(interviewData.end_time, 'h:mm');
    dateDifference(now, prev);

    return (
        <div>
            <div className="d-flex justify-content-end mt-4">
                <button
                    className="btn hive-btn-primary bold-text font-12"
                    type="button"
                    onClick={() => {
                        setOffcanvasVisible(true)
                        setSubmitInterviewMode('Insert');
                        setShowContainer(true);
                        setInterviewData({
                            ...interviewData,
                            availabilityStatus: 'Available',
                        });
                    }}
                >
                    Schedule Interview
                </button>
            </div>
            {bindMeetings()}
            <Popup
                deleteData={() => {
                    deleteInterviewClick();
                }}
            />

            {/*offcanvas section starts here*/}
            {showFeedback && (
                <div className="offcanvas offcanvas-end z-index custom-offcanvas-style show" style={{ visibility: 'visible' }}>
                    <div className="offcanvas-header mt-3">
                        <h5 id="offcanvasRightLabel bold-text font-18 add-feedback-header">Add Feedback</h5>
                        <button
                            type="button"
                            onClick={() => {
                                cancelClick();
                            }}
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        />
                    </div>
                    <div className="offcanvas-body mb-5">
                        <div className="row">
                            <div className="col-md-6 mt-2">
                                <div className="d-flex">
                                    <div className="candidate-prof-container">
                                        <img
                                            src={imageUrls.candidate || '/Images/candidate-prof.svg'}
                                            className="candidate-profile-icon"
                                            alt="candidate profile"
                                        />
                                    </div>
                                    <div className="ms-2 ps-2">
                                        <label href="#" className="mb-0 font-16 semibold-text mt-2">
                                            {scheduledInterviewData.Name}
                                        </label>
                                        <p className="mb-0 font-12 regular-text mt-2">
                                            For Position
                                            <span className="semibold-text">- {scheduledInterviewData.position}</span>
                                        </p>
                                        <p className="mb-0 font-12 regular-text mt-2">
                                            Stage
                                            <span className="semibold-text">- {scheduledInterviewData.stage}</span>
                                        </p>
                                        <p className="mb-0 font-12 regular-text mt-2" />
                                        <p className="mb-0 font-12 regular-text">Scheduled by {scheduledInterviewData.scheduled}</p>
                                        <p />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mt-2 pt-1">
                                <div className="w-100">
                                    <img src="/Images/Interview-calender.svg" alt="calendar-img" className="me-2" />
                                    <label className="bold-text font-12 mt-2">{moment(scheduledInterviewData.date).format('ll')}</label>
                                </div>
                                <div className="w-100">
                                    <img src="/Images/Interview-clock.svg" alt="clock-img" className="me-2" />
                                    <label className="bold-text font-12">{scheduledInterviewData.duration}</label>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                {/* <label className="bold-text font-14 mb-2">
                                    Status<span className="hive-form-mandatory">*</span>:{' '}
                                </label>
                                <div className="w-100 float-start">
                                    <button
                                        className={rednoShow}
                                        id="recommendation_id"
                                        onClick={(e) => handleFeedbackChange(e)}
                                        value={'3'}
                                    >
                                        <span>
                                            <img src="/Images/Interview-noshow.svg" className="btn-size" />
                                        </span>
                                        No Show
                                    </button>
                                    <button
                                        className={redreject}
                                        id="recommendation_id"
                                        onClick={(e) => handleFeedbackChange(e)}
                                        value={'2'}
                                    >
                                        <span>
                                            <img src="/Images/Cross-task.svg" className="btn-size" />
                                        </span>
                                        Rejected
                                    </button>
                                    <button
                                        className={greenSelect}
                                        id="recommendation_id"
                                        onClick={(e) => handleFeedbackChange(e)}
                                        value={'1'}
                                    >
                                        <span>
                                            <img src="/Images/tick-task.svg" className="btn-size" />
                                        </span>
                                        Selected
                                    </button>
                                </div> */}
                                <label className="bold-text font-14 mb-2">
                                    Status<span className="hive-form-mandatory">*</span>{' '}
                                </label>

                                <div class="dropdown">
                                    <button
                                        class="btn hive-form-select custom-textfield font-14 regular-text w-50 form-select text-start"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        value={AddFeedBack}
                                    >
                                        <span>
                                            <img
                                                src={
                                                    AddFeedBack.recommendation_id == 1
                                                        ? '/Images/selected-icon.svg'
                                                        : AddFeedBack.recommendation_id == 2
                                                            ? '/Images/rejected-icon.svg'
                                                            : AddFeedBack.recommendation_id == 3
                                                                ? '/Images/onhold-icon.svg'
                                                                : AddFeedBack.recommendation_id == 4
                                                                    ? '/Images/delegate-icon.svg'
                                                                    : AddFeedBack.recommendation_id == 5
                                                                        ? '/Images/noshow-icon.svg'
                                                                        : AddFeedBack.recommendation_id == 6
                                                                            ? '/Images/Reschedule.svg'
                                                                            : ''
                                                }
                                                className="btn-size"
                                            />
                                        </span>
                                        {AddFeedBack.recommendation_id == 1
                                            ? AddFeedBack.statusResult
                                            : AddFeedBack.recommendation_id == 2
                                                ? AddFeedBack.statusResult
                                                : AddFeedBack.recommendation_id == 3
                                                    ? AddFeedBack.statusResult
                                                    : AddFeedBack.recommendation_id == 4
                                                        ? AddFeedBack.statusResult
                                                        : AddFeedBack.recommendation_id == 5
                                                            ? AddFeedBack.statusResult
                                                            : AddFeedBack.recommendation_id == 6
                                                                ? AddFeedBack.statusResult
                                                                : 'Select'}
                                    </button>
                                    <ul class="dropdown-menu px-2 w-50" aria-labelledby="dropdownMenuButton1">
                                        <li className=" font-14 regular-text border-0">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="1"
                                                name="statusResult"
                                                value="Selected"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/selected-icon.svg" className="btn-size" />
                                                </span>
                                                Selected
                                            </a>
                                        </li>
                                        <li className="font-14 regular-text border-0">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="2"
                                                name="statusResult"
                                                value="Rejected"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/rejected-icon.svg" className="btn-size" />
                                                </span>
                                                Rejected
                                            </a>
                                        </li>
                                        <li className=" font-14 regular-text border-0">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="3"
                                                name="statusResult"
                                                value="On Hold"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/onhold-icon.svg" className="btn-size" />
                                                </span>
                                                On Hold
                                            </a>
                                        </li>
                                        <li className="font-14 regular-text border-0 ">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="4"
                                                name="statusResult"
                                                value="Delegate"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/delegate-icon.svg" className="btn-size" />
                                                </span>
                                                Delegate
                                            </a>
                                        </li>

                                        <li className=" font-14 regular-text border-0">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="5"
                                                name="statusResult"
                                                value="No Show"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/noshow-icon.svg" className="btn-size" />
                                                </span>
                                                No Show
                                            </a>
                                        </li>
                                        <li className=" font-14 regular-text border-0">
                                            <a
                                                className="dropdown-item p-2"
                                                href="#"
                                                id="6"
                                                name="statusResult"
                                                value="Reschedule"
                                                onClick={(e) => {
                                                    handleFeedbackChange(e);
                                                }}
                                            >
                                                <span>
                                                    <img src="/Images/Reschedule.svg" className="btn-size" />
                                                </span>
                                                Reschedule
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <span style={{ color: 'red' }}>{message.status}</span>
                            {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2 w-100" htmlFor="attitute-feedback">
                                        Attitude <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.attitude}
                                        className="form-control custom-comment-box custom-textfield"
                                        id="attitude"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.attitude}</span>
                                </div>
                            ) : (
                                ''
                            )}
                            {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2" htmlFor="communication-feedback">
                                        Communication <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.communication}
                                        className="form-control custom-comment-box custom-textfield"
                                        id="communication"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.communication}</span>
                                </div>
                            ) : (
                                ''
                            )}
                            {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2" htmlFor="business-feedback">
                                        Business <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.business}
                                        className="form-control custom-comment-box custom-textfield"
                                        id="business"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.business}</span>
                                </div>
                            ) : (
                                ''
                            )}
                            {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2" htmlFor="technology-feedback">
                                        Technology <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.technology}
                                        className="form-control custom-comment-box custom-textfield"
                                        id="technology"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.technology}</span>
                                </div>
                            ) : (
                                ''
                            )}
                            {AddFeedBack.recommendation_id == 6 ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2" htmlFor="reason_for_reschedule-feedback">
                                        Reason for Rescheduling <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.reason_for_reschedule}
                                        className="form-control custom-comment-box custom-textfield"
                                        id="reason_for_reschedule"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.reason_for_reschedule}</span>
                                </div>
                            ) : (
                                ''
                            )}
                            {(AddFeedBack.recommendation_id !== 6) ? (
                                <div className="col-md-12 mb-3">
                                    <label className="font-14 semibold-text my-2" htmlFor="comments-feedback">
                                        Overall Comments <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        placeholder="Enter here"
                                        value={AddFeedBack.overAllComments}
                                        className="form-control recruit-overall-comments custom-textfield"
                                        id="overAllComments"
                                        onChange={handleFeedbackChange}
                                        maxLength={255}
                                    />
                                    <span style={{ color: 'red' }}>{message.overAllComments}</span>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        {/* PS_CB_03 */}
                        {(AddFeedBack.recommendation_id !== 6) ? (
                            <div class="col-md-4 ">
                                <input class="form-check-input hive-form-check-input me-2 job-posting-checkbox"
                                    type="checkbox" id="is_check"
                                    value={AddFeedBack.is_check}
                                    checked={AddFeedBack.is_check}
                                    //PS_CB_04
                                    onClick={(event) => setAddFeedBack({ ...AddFeedBack, [event.target.id]: event.target.checked })} />
                                <label class="form-check-label hive-form-check-label font-13 semibold-text" for="remote">
                                    Notify Candidate through mail</label>
                            </div>
                        ) : (
                            ''
                        )}
                        {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'HR Discussion' && (scheduledInterviewData.stage === 'Technical Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round')) ? (
                            <div className="row align-items-center">
                                {(() => {
                                    AddFeedBack.interview_round_name = scheduledInterviewData.stage;
                                    return null;
                                })()}
                                <h6 className='family_details'>Family Details</h6>
                                <p className='modal-title'>Father Details</p>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="father_occupation">
                                        Occupation
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="father_occupation"
                                        placeholder="Enter Occupation"
                                        value={AddFeedBack.father_occupation}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.father_occupation}</span>
                                </div>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="father_salary">
                                        Salary
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="father_salary"
                                        placeholder="Enter Salary with CTC/LPA or NA"
                                        value={AddFeedBack.father_salary}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.father_salary}</span>
                                </div>
                                <p className='modal-title'>Mother Details</p>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="mother_occupation">
                                        Occupation
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="mother_occupation"
                                        placeholder="Enter Occupation"
                                        value={AddFeedBack.mother_occupation}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.mother_occupation}</span>
                                </div>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="mother_salary">
                                        Salary
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="mother_salary"
                                        placeholder="Enter Salary with CTC/LPA or NA"
                                        value={AddFeedBack.mother_salary}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.mother_salary}</span>
                                </div>
                                <div>


                                    {AddFeedBack.siblings.map((sibling, index) => (
                                        <div key={index}>
                                            <div className="sibling-header">
                                                <p className='modal-title-align'>{AddFeedBack.siblings.length === 1 ? 'Sibling Details' : `Sibling Details ${index + 1}`}</p>
                                                {index > 0 && (
                                                    <button className='removeSibling' onClick={() => removeSibling(sibling, index)}>
                                                        <span>
                                                            <img src="/Images/Remove_Sibling.svg" className="btn-sibling-size" />
                                                        </span>
                                                        Remove</button>
                                                )}
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-md-4-family-fields">
                                                    <label className="font-14 semibold-text my-2" htmlFor={`sibling-occupation-${index}`}>Occupation</label>
                                                    <input
                                                        type="text"
                                                        className="form-control hive-form-control"
                                                        id={`sibling-occupation-${index}`}
                                                        name="occupation"
                                                        value={sibling.occupation}
                                                        onChange={(e) => handleFeedbackChange(e, index)}
                                                        placeholder="Enter Occupation"
                                                    />
                                                    {message[`sibling_occupation_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_occupation_${index}`]}</span>}
                                                </div>
                                                <div className="col-md-4-family-fields">
                                                    <label className="font-14 semibold-text my-2" htmlFor={`sibling-salary-${index}`}>Salary</label>
                                                    <input
                                                        type="text"
                                                        className="form-control hive-form-control"
                                                        name="salary"
                                                        id={`sibling-salary-${index}`}
                                                        value={sibling.salary}
                                                        onChange={(e) => handleFeedbackChange(e, index)}
                                                        placeholder="Enter Salary with CTC/LPA or NA"
                                                    />
                                                    {message[`sibling_salary_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_salary_${index}`]}</span>}
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                    {AddFeedBack.siblings.length > 0 && (
                                        <button className='addSibling' disabled={!feedBackDisabled} onClick={addSibling}>
                                            <span>
                                                <img src="/Images/Add_Sibling.svg" className="btn-sibling-size" />
                                            </span>
                                            Add Sibling</button>
                                    )}
                                </div>
                                <p className='modal-title'>Location Details</p>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="current_location">
                                        Current Location
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="current_location"
                                        placeholder="Enter Current Location"
                                        value={AddFeedBack.current_location}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.current_location}</span>
                                </div>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="native_location">
                                        Native Location
                                        {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="native_location"
                                        placeholder="Enter Native District"
                                        value={AddFeedBack.native_location}
                                        onChange={handleFeedbackChange}
                                    />
                                    <span style={{ color: 'red' }}>{message.native_location}</span>
                                </div>
                            </div>
                        ) : (
                            ''
                        )}

                        {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && (scheduledInterviewData.stage === 'HR Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round' || scheduledInterviewData.stage === 'Technical Discussion') && AddFeedBack.recommendation_id != 2) ? (
                            <div className="row align-items-center">
                                <p className='modal-title'>Other Details</p>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="ctc">
                                        {scheduledInterviewData.stage === 'HR Discussion' ? 'Final CTC Offered' : 'CTC Offered'}
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="ctc"
                                        placeholder="Enter CTC"
                                        value={AddFeedBack.ctc}
                                        onChange={handleFeedbackChange}
                                        maxLength={6}
                                    />
                                    <span style={{ color: 'red' }}>{message.ctc}</span>
                                </div>
                                <div className="col-md-4-family-fields">
                                    <label className="font-14 semibold-text my-2" htmlFor="domain">
                                        Domain
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        type="text"
                                        className="hive-form-control form-select-domain"
                                        id="domain"
                                        placeholder="Enter CTC"
                                        value={AddFeedBack.domain}
                                        onChange={handleFeedbackChange}
                                    >
                                        <option value="">Select</option>
                                        {bindDomain()}
                                    </select>
                                    <span style={{ color: 'red' }}>{message.domain}</span>
                                </div>

                            </div>
                        ) : (
                            ''
                        )}
                        <div className="col-md-12 d-flex justify-content-end mb-4 mt-5">
                            <button
                                className="btn hive-btn-secondary me-2"
                                onClick={() => {
                                    cancelClick();
                                }}
                            // data-bs-dismiss="offcanvas"
                            >
                                Cancel
                            </button>
                            <button
                                className="btn hive-btn-primary"
                                onClick={() => {

                                    submitFeedBack(scheduledInterviewData.stage);
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    {isLoadingLoader == false ? <Loader isLoading={isLoadingLoader} /> : null}
                </div>
            )}

            {/*****VIEW FEEDBACK********* */}

            <div className="offcanvas offcanvas-end z-index custom-offcanvas-style " tabIndex={-1} id="offcanvasRightView">
                <div className="offcanvas-header">
                    {/* PC_FB_04 -> Feedback form is bound based on the conditions either in View or Edit and the respective view of the form is bound*/}
                    <h5 id="offcanvasRightLabel bold-text font-18 add-feedback-headerw">
                        {updateButton == 'Edit' ? 'View' : 'Edit'} Feedback
                    </h5>
                    <button
                        onClick={() => {
                            cancelClick();
                        }}
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="offcanvas-body">
                    <div className="row">
                        <div className="col-md-6 mt-2">
                            <div className="d-flex">
                                <div className="candidate-prof-container">
                                    <img
                                        src={imageUrls.candidate || '/Images/candidate-prof.svg'}
                                        className="candidate-profile-icon"
                                        alt="candidate profile"
                                    />
                                </div>
                                <div className="ms-2 ps-2">
                                    <label href="#" className="mb-0 font-16 semibold-text mt-2">
                                        {candidateName}
                                    </label>
                                    <p className="mb-0 font-12 regular-text mt-2">
                                        For Position
                                        <span className="semibold-text">- {scheduledInterviewData.Position}</span>
                                    </p>
                                    <p className="mb-0 font-12 regular-text mt-2">
                                        Stage
                                        <span className="semibold-text">- {scheduledInterviewData.stage}</span>
                                    </p>
                                    <p className="mb-0 font-12 regular-text mt-2" />
                                    <p className="mb-0 font-12 regular-text">Scheduled by {scheduledInterviewData?.scheduled} </p>
                                    <p />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-2 pt-1">
                            <div className="w-100">
                                <img src="/Images/Interview-calender.svg" alt="calendar-img" className="me-2" />
                                <label className="bold-text font-12 mt-2">{moment(feedbackView?.interview_date).format('ll')}</label>
                            </div>
                            <div className="w-100">
                                <img src="/Images/Interview-clock.svg" alt="clock-img" className="me-2" />
                                <label className="bold-text font-12">{scheduledInterviewData.duration}</label>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="bold-text font-14 mb-2">
                                Status<span className="hive-form-mandatory">*</span>:{' '}
                            </label>

                            <div class="dropdown">
                                <button
                                    class="btn hive-form-select custom-textfield font-14 regular-text w-50 form-select text-start"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    value={AddFeedBack}
                                    disabled={feedBackDisabled}
                                >
                                    <span>
                                        <img
                                            src={
                                                AddFeedBack.recommendation_id == 1
                                                    ? '/Images/selected-icon.svg'
                                                    : AddFeedBack.recommendation_id == 2
                                                        ? '/Images/rejected-icon.svg'
                                                        : AddFeedBack.recommendation_id == 3
                                                            ? '/Images/onhold-icon.svg'
                                                            : AddFeedBack.recommendation_id == 4
                                                                ? '/Images/delegate-icon.svg'
                                                                : AddFeedBack.recommendation_id == 5
                                                                    ? '/Images/noshow-icon.svg'
                                                                    : AddFeedBack.recommendation_id == 6
                                                                        ? '/Images/Reschedule.svg'
                                                                        : ''
                                            }
                                            className="btn-size"
                                        />
                                    </span>
                                    {AddFeedBack.recommendation_id == 1
                                        ? AddFeedBack.statusResult
                                        : AddFeedBack.recommendation_id == 2
                                            ? AddFeedBack.statusResult
                                            : AddFeedBack.recommendation_id == 3
                                                ? AddFeedBack.statusResult
                                                : AddFeedBack.recommendation_id == 4
                                                    ? AddFeedBack.statusResult
                                                    : AddFeedBack.recommendation_id == 5
                                                        ? AddFeedBack.statusResult
                                                        : AddFeedBack.recommendation_id == 6
                                                            ? AddFeedBack.statusResult
                                                            : 'Select'}
                                </button>
                                <ul class="dropdown-menu px-2 w-50" aria-labelledby="dropdownMenuButton1">
                                    <li className=" font-14 regular-text border-0">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="1"
                                            name="statusResult"
                                            value="Selected"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/selected-icon.svg" className="btn-size" />
                                            </span>
                                            Selected
                                        </a>
                                    </li>
                                    <li className="font-14 regular-text border-0">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="2"
                                            name="statusResult"
                                            value="Rejected"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/rejected-icon.svg" className="btn-size" />
                                            </span>
                                            Rejected
                                        </a>
                                    </li>
                                    <li className=" font-14 regular-text border-0">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="3"
                                            name="statusResult"
                                            value="On Hold"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/onhold-icon.svg" className="btn-size" />
                                            </span>
                                            On Hold
                                        </a>
                                    </li>
                                    <li className="font-14 regular-text border-0 ">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="4"
                                            name="statusResult"
                                            value="Delegate"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/delegate-icon.svg" className="btn-size" />
                                            </span>
                                            Delegate
                                        </a>
                                    </li>

                                    <li className=" font-14 regular-text border-0">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="5"
                                            name="statusResult"
                                            value="No Show"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/noshow-icon.svg" className="btn-size" />
                                            </span>
                                            No Show
                                        </a>
                                    </li>
                                    <li className=" font-14 regular-text border-0">
                                        <a
                                            className="dropdown-item p-2"
                                            href="#"
                                            id="6"
                                            name="statusResult"
                                            value="Reschedule"
                                            onClick={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                        >
                                            <span>
                                                <img src="/Images/Reschedule.svg" className="btn-size" />
                                            </span>
                                            Reschedule
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="w-100 float-start">
                                <button
                                    className="custom-task-red-btn font-14 regular-text me-2"
                                    disabled={true}
                                    hidden={feedbackView[0]?.overall_recommendation_id == 3 ? false : true}
                                >
                                    <span>
                                        <img src="/Images/Interview-noshow.svg" className="btn-size" />
                                    </span>
                                    No Show
                                </button>
                                <button
                                    className="custom-task-red-btn font-14 regular-text me-2"
                                    disabled={true}
                                    hidden={feedbackView[0]?.overall_recommendation_id == 2 ? false : true}
                                >
                                    <span>
                                        <img src="/Images/Cross-task.svg" className="btn-size" />
                                    </span>
                                    Rejected
                                </button>
                                <button
                                    className="custom-task-green-btn font-14 regular-text"
                                    disabled={true}
                                    hidden={feedbackView[0]?.overall_recommendation_id == 1 ? false : true}
                                >
                                    <span>
                                        <img src="/Images/tick-task.svg" className="btn-size" />
                                    </span>
                                    Selected
                                </button>
                            </div> */}
                        </div>
                        {/* PC_FB_04 -> feedbackView length is checked for equal to 4 */}
                        {feedbackView.length > 4 || feedbackView.gd_feedback ? (
                            <>
                                <div className="col-md-12">{bindPreviousComments()}</div>

                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2 w-100" htmlFor="attitute-feedback">
                                            Attitude
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[0]?.comments == undefined ? '' : AddFeedBack.attitude}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="attitude"
                                            onChange={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="communication-feedback">
                                            Communication
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[1]?.comments == undefined ? '' : AddFeedBack.communication}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="communication"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="business-feedback">
                                            Business
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[2]?.comments == undefined ? '' : AddFeedBack.business}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="business"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="technology-feedback">
                                            Technology
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[3]?.comments == undefined ? '' : AddFeedBack.technology}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="technology"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {AddFeedBack.recommendation_id == 6 ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="reason_for_reschedule-feedback">
                                            Reason for Rescheduling
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={AddFeedBack.reason_for_reschedule}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="reason_for_reschedule"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="comments-feedback">
                                            Overall Comments
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={
                                                feedbackView[0]?.overall_comments == undefined &&
                                                    feedbackView?.gd_feedback?.[0].overall_comments == undefined
                                                    ? ''
                                                    : AddFeedBack.overAllComments
                                            }
                                            className="form-control recruit-overall-comments custom-textfield"
                                            id="overAllComments"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6) ? (
                                    <div class="col-md-4 ">
                                        <input class="form-check-input hive-form-check-input me-2 job-posting-checkbox"
                                            type="checkbox" id="is_check"
                                            disabled={feedBackDisabled}
                                            value={AddFeedBack.is_check}
                                            checked={
                                                feedbackView[0]?.is_check == undefined &&
                                                    feedbackView?.gd_feedback?.[0]?.is_check == undefined
                                                    ? false
                                                    : AddFeedBack.is_check}

                                            onClick={(event) => setAddFeedBack({ ...AddFeedBack, [event.target.id]: event.target.checked })} />
                                        <label class="form-check-label hive-form-check-label font-13 semibold-text" for="remote">
                                            Notify Candidate through mail</label>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'HR Discussion' && (scheduledInterviewData.stage === 'Technical Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round')) ? (
                                    <div className="row align-items-center">
                                        {(() => {
                                            AddFeedBack.interview_round_name = scheduledInterviewData.stage;
                                            return null;
                                        })()}
                                        <h6 className='family_details'>Family Details</h6>
                                        <p className='modal-title'>Father Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="father_occupation">
                                                Occupation
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="father_occupation"
                                                placeholder="Enter Occupation"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.father_occupation}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.father_occupation}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="father_salary">
                                                Salary
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="father_salary"
                                                placeholder="Enter Salary with CTC/LPA or NA" disabled={feedBackDisabled}
                                                maxLength={6}
                                                value={AddFeedBack.father_salary}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.father_salary}</span>
                                        </div>
                                        <p className='modal-title'>Mother Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="mother_occupation">
                                                Occupation
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="mother_occupation"
                                                placeholder="Enter Occupation"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.mother_occupation}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.mother_occupation}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="mother_salary">
                                                Salary
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="mother_salary"
                                                placeholder="Enter Salary with CTC/LPA or NA" disabled={feedBackDisabled}
                                                maxLength={6}
                                                value={AddFeedBack.mother_salary}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.mother_salary}</span>
                                        </div>
                                        <div>


                                            {AddFeedBack.siblings.map((sibling, index) => (
                                                <div key={index}>
                                                    <div className="sibling-header">
                                                        <p className='modal-title-align'>{AddFeedBack.siblings.length === 1 ? 'Sibling Details' : `Sibling Details ${index + 1}`}</p>
                                                        {(updateButton === 'Edit' || updateButton === '') ? null : (index > 0 && (
                                                            <button className='removeSibling' disabled={feedBackDisabled} onClick={() => removeSibling(sibling, index)}>
                                                                <span>
                                                                    <img src="/Images/Remove_Sibling.svg" className="btn-sibling-size" />
                                                                </span>
                                                                Remove</button>
                                                        ))}
                                                    </div>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-4-family-fields">
                                                            <label className="font-14 semibold-text my-2" htmlFor={`sibling-occupation-${index}`}>Occupation</label>
                                                            <input
                                                                type="text"
                                                                className="form-control hive-form-control"
                                                                id={`sibling-occupation-${index}`}
                                                                name="occupation"
                                                                disabled={feedBackDisabled}
                                                                value={sibling.occupation}
                                                                onChange={(e) => handleFeedbackChange(e, index)}
                                                                placeholder="Enter Occupation"
                                                            />
                                                            {message[`sibling_occupation_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_occupation_${index}`]}</span>}
                                                        </div>
                                                        <div className="col-md-4-family-fields">
                                                            <label className="font-14 semibold-text my-2" htmlFor={`sibling-salary-${index}`}>Salary</label>
                                                            <input
                                                                type="text"
                                                                className="form-control hive-form-control"
                                                                name="salary"
                                                                id={`sibling-salary-${index}`}
                                                                disabled={feedBackDisabled}
                                                                value={sibling.salary}
                                                                onChange={(e) => handleFeedbackChange(e, index)}
                                                                placeholder="Enter Salary with CTC/LPA or NA"
                                                                maxLength={6}
                                                            />
                                                            {message[`sibling_salary_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_salary_${index}`]}</span>}
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                            {(updateButton === 'Edit' || updateButton === '') ? null : (AddFeedBack.siblings.length > 0 && (
                                                <button className='addSibling' disabled={feedBackDisabled} onClick={addSibling}>
                                                    <span>
                                                        <img src="/Images/Add_Sibling.svg" className="btn-sibling-size" alt="Add Sibling" />
                                                    </span>
                                                    Add Sibling
                                                </button>
                                            ))}
                                        </div>
                                        <p className='modal-title'>Location Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="current_location">
                                                Current Location
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="current_location"
                                                placeholder="Enter Current Location"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.current_location}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.current_location}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="native_location">
                                                Native Location
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="native_location"
                                                placeholder="Enter Native District"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.native_location}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.native_location}</span>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && (scheduledInterviewData.stage === 'HR Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round' || scheduledInterviewData.stage === 'Technical Discussion') && AddFeedBack.recommendation_id != 2) ? (
                                    <div className="row align-items-center">
                                        <p className='modal-title'>Other Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="ctc">
                                                CTC
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="ctc"
                                                placeholder="Enter CTC"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.ctc}
                                                maxLength={6}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.ctc}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="domain">
                                                Domain
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                type="text"
                                                className="hive-form-control form-select-domain"
                                                id="domain"
                                                placeholder="Enter CTC"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.domain}
                                                onChange={handleFeedbackChange}
                                            >
                                                <option value="">Select</option>
                                                {bindDomain()}
                                            </select>
                                            <span style={{ color: 'red' }}>{message.domain}</span>
                                        </div>

                                    </div>
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            <></>
                        )}

                        {feedbackView.length == 4 ? (
                            <>
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2 w-100" htmlFor="attitute-feedback">
                                            Attitude
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[0]?.comments == undefined ? '' : AddFeedBack.attitude}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="attitude"
                                            onChange={(e) => {
                                                handleFeedbackChange(e);
                                            }}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="communication-feedback">
                                            Communication
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[1]?.comments == undefined ? '' : AddFeedBack.communication}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="communication"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="business-feedback">
                                            Business
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[2]?.comments == undefined ? '' : AddFeedBack.business}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="business"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(scheduledInterviewData.stage !== 'Group Discussion' && AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="technology-feedback">
                                            Technology
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[3]?.comments == undefined ? '' : AddFeedBack.technology}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="technology"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {AddFeedBack.recommendation_id == 6 ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="reason_for_reschedule-feedback">
                                            Reason for Rescheduling
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={AddFeedBack.reason_for_reschedule}
                                            className="form-control custom-comment-box custom-textfield"
                                            id="reason_for_reschedule"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6) ? (
                                    <div className="col-md-12 mb-3">
                                        <label className="font-14 semibold-text my-2" htmlFor="comments-feedback">
                                            Overall Comments
                                        </label>
                                        <textarea
                                            placeholder="Enter here"
                                            disabled={feedBackDisabled}
                                            value={feedbackView[0]?.overall_comments == undefined ? '' : AddFeedBack.overAllComments}
                                            className="form-control recruit-overall-comments custom-textfield"
                                            id="overAllComments"
                                            onChange={handleFeedbackChange}
                                            maxLength={255}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6) ? (
                                    <div class="col-md-4 ">
                                        <input class="form-check-input hive-form-check-input me-2 job-posting-checkbox"
                                            type="checkbox" id="is_check"
                                            disabled={feedBackDisabled}
                                            value={AddFeedBack.is_check}
                                            checked={
                                                feedbackView[0]?.is_check == undefined
                                                    ? false
                                                    : AddFeedBack.is_check}

                                            onClick={(event) => setAddFeedBack({ ...AddFeedBack, [event.target.id]: event.target.checked })} />
                                        <label class="form-check-label hive-form-check-label font-13 semibold-text" for="remote">
                                            Notify Candidate through mail</label>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && scheduledInterviewData.stage !== 'HR Discussion' && (scheduledInterviewData.stage === 'Technical Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round')) ? (
                                    <div className="row align-items-center">
                                        {(() => {
                                            AddFeedBack.interview_round_name = scheduledInterviewData.stage;
                                            return null;
                                        })()}
                                        <h6 className='family_details'>Family Details</h6>
                                        <p className='modal-title'>Father Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="father_occupation">
                                                Occupation
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="father_occupation"
                                                placeholder="Enter Occupation"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.father_occupation}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.father_occupation}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="father_salary">
                                                Salary
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="father_salary"
                                                placeholder="Enter Salary with CTC/LPA or NA"
                                                maxLength={6}
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.father_salary}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.father_salary}</span>
                                        </div>
                                        <p className='modal-title'>Mother Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="mother_occupation">
                                                Occupation
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="mother_occupation"
                                                placeholder="Enter Occupation"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.mother_occupation}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.mother_occupation}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="mother_salary">
                                                Salary
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="mother_salary"
                                                placeholder="Enter Salary with CTC/LPA or NA"
                                                maxLength={6}
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.mother_salary}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.mother_salary}</span>
                                        </div>
                                        <div>


                                            {AddFeedBack.siblings.map((sibling, index) => (
                                                <div key={index}>
                                                    <div className="sibling-header">
                                                        <p className='modal-title-align'>{AddFeedBack.siblings.length === 1 ? 'Sibling Details' : `Sibling Details ${index + 1}`}</p>
                                                        {index > 0 && (
                                                            <button className='removeSibling' disabled={feedBackDisabled} onClick={() => removeSibling(sibling, index)}>
                                                                <span>
                                                                    <img src="/Images/Remove_Sibling.svg" className="btn-sibling-size" />
                                                                </span>
                                                                Remove</button>
                                                        )}
                                                    </div>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-4-family-fields">
                                                            <label className="font-14 semibold-text my-2" htmlFor={`sibling-occupation-${index}`}>Occupation</label>
                                                            <input
                                                                type="text"
                                                                className="form-control hive-form-control"
                                                                id={`sibling-occupation-${index}`}
                                                                name="occupation"
                                                                disabled={feedBackDisabled}
                                                                value={sibling.occupation}
                                                                onChange={(e) => handleFeedbackChange(e, index)}
                                                                placeholder="Enter Occupation"
                                                            />
                                                            {message[`sibling_occupation_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_occupation_${index}`]}</span>}
                                                        </div>
                                                        <div className="col-md-4-family-fields">
                                                            <label className="font-14 semibold-text my-2" htmlFor={`sibling-salary-${index}`}>Salary</label>
                                                            <input
                                                                type="text"
                                                                className="form-control hive-form-control"
                                                                name="salary"
                                                                disabled={feedBackDisabled}
                                                                id={`sibling-salary-${index}`}
                                                                value={sibling.salary}
                                                                onChange={(e) => handleFeedbackChange(e, index)}
                                                                placeholder="Enter Salary with CTC/LPA or NA"
                                                                maxLength={6}
                                                            />
                                                            {message[`sibling_salary_${index}`] && <span style={{ color: 'red' }}>{message[`sibling_salary_${index}`]}</span>}
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}
                                            {AddFeedBack.siblings.length > 0 && (
                                                <button className='addSibling' disabled={feedBackDisabled} onClick={addSibling}>
                                                    <span>
                                                        <img src="/Images/Add_Sibling.svg" className="btn-sibling-size" />
                                                    </span>
                                                    Add Sibling</button>
                                            )}
                                        </div>
                                        <p className='modal-title'>Location Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="current_location">
                                                Current Location
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="current_location"
                                                placeholder="Enter Current Location"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.current_location}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.current_location}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="native_location">
                                                Native Location
                                                {scheduledInterviewData.stage === 'Technical Discussion' && <span className="hive-form-mandatory">*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="native_location"
                                                placeholder="Enter Native District"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.native_location}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.native_location}</span>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}

                                {(AddFeedBack.recommendation_id !== 6 && scheduledInterviewData.stage !== 'Group Discussion' && (scheduledInterviewData.stage === 'HR Discussion' || scheduledInterviewData.stage === 'Avasoft Final Round' || scheduledInterviewData.stage === 'Technical Discussion') && AddFeedBack.recommendation_id != 2) ? (
                                    <div className="row align-items-center">
                                        <p className='modal-title'>Other Details</p>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="ctc">
                                                CTC Offered
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="ctc"
                                                placeholder="Enter CTC"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.ctc}
                                                maxLength={6}
                                                onChange={handleFeedbackChange}
                                            />
                                            <span style={{ color: 'red' }}>{message.ctc}</span>
                                        </div>
                                        <div className="col-md-4-family-fields">
                                            <label className="font-14 semibold-text my-2" htmlFor="domain">
                                                Domain
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                type="text"
                                                className="hive-form-control form-select-domain"
                                                id="domain"
                                                placeholder="Enter CTC"
                                                disabled={feedBackDisabled}
                                                value={AddFeedBack.domain}
                                                onChange={handleFeedbackChange}
                                            >
                                                <option value="">Select</option>
                                                {bindDomain()}
                                            </select>
                                            <span style={{ color: 'red' }}>{message.domain}</span>
                                        </div>

                                    </div>
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="col-md-12 d-flex justify-content-end mb-4 mt-5">
                        <button
                            type="button"
                            className="btn hive-btn-secondary me-4"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            onClick={() => {
                                cancelClick();
                            }}
                        >
                            Cancel
                        </button>
                        {/* PC_FB_06 -> Edit/View Button trigers the function updateCandidateFeedback() */}
                        <button
                            className="btn hive-btn-primary"
                            // data-bs-dismiss="offcanvas"
                            value={updateButton == 'Update' ? 'Update' : 'Edit'}
                            onClick={(e) => {
                                updateCandidateFeedback(e);
                            }}
                        >
                            {updateButton == 'Update' ? 'Update' : 'Edit'}
                        </button>
                    </div>
                </div>
            </div>
            {/** VIEW FEEDBACK ENDS HERE*/}

            {/** SCHEDULE INTERVIEW LEFT PANEL POPUP */}

            {/** SCHEDULE INTERVIEW LEFT PANEL POPUP */}
            {isOffcanvasVisible && (

                <>
                    <div
                        className="offcanvas offcanvas-end schedule-interview-offcanvas pt-2 px-2 show"
                        style={{ visibility: 'visible' }}
                    >
                        <div className="offcanvas-header mb-4">
                            <h5 className="mb-0 bold-text font-18 schedule-interview-header-color">Schedule Interview</h5>
                            <button
                                onClick={interviewCancelClick}
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            />
                        </div>
                        <div className="offcanvas-body">
                            <div className="row align-items-end">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label hive-form-label">
                                        Candidate's Availability<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                id="availableRadio"
                                                name="availabilityStatus"
                                                value="Available"
                                                checked={interviewData.availabilityStatus === "Available"}
                                                onChange={onInterviewValue}
                                            />
                                            <label className="form-check-label" htmlFor="availableRadio">Available</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                id="notAvailableRadio"
                                                name="availabilityStatus"
                                                value="Not Available"
                                                checked={interviewData.availabilityStatus === "Not Available"}
                                                onChange={onInterviewValue}
                                            />
                                            <label className="form-check-label" htmlFor="notAvailableRadio">Not Available</label>
                                        </div>
                                    </div>
                                </div>

                                {interviewData.availabilityStatus === "Not Available" ? (
                                    <>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="interview_round_id">
                                                Select Interview Round <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select regular-text custom-textfield"
                                                id="interview_round_id"
                                                onChange={onInterviewValue}
                                                value={interviewData.interview_round_id}
                                            >
                                                <option value="">Select</option>
                                                {bindInterviewRound()}
                                            </select>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="comments">
                                                Comments
                                            </label>
                                            <textarea
                                                className="form-control hive-form-control custom-textfield schedule-interview-commentbox regular-text"
                                                onChange={onInterviewValue}
                                                value={interviewData.comments}
                                                placeholder="Enter comments"
                                                id="comments"
                                            />
                                            <span style={{ color: 'red' }}>{commentsValidation}</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="title">
                                                Title<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control custom-textfield regular-text"
                                                onChange={onInterviewValue}
                                                id="title"
                                                value={interviewData.title}
                                                maxLength={80}
                                                placeholder="Enter Title"
                                            />
                                            <span style={{ color: 'red' }}>{titleValidation}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="meeting-details">
                                                Meeting Details
                                            </label>
                                            <textarea
                                                className="form-control hive-form-control custom-textfield schedule-interview-commentbox regular-text"
                                                onChange={onInterviewValue}
                                                value={interviewData.meeting_details}
                                                placeholder="Enter Meeting details"
                                                id="meeting_details"
                                                maxLength={225}
                                            />
                                            <span style={{ color: 'red' }}>{meetingDetailsValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="interview-round">
                                                Select Interview Round
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            {submitInterviewMode === 'Insert' ? (
                                                <select
                                                    className="form-select hive-form-select regular-text custom-textfield"
                                                    id="interview_round_id"
                                                    onChange={onInterviewValue}
                                                    value={interviewData.interview_round_id}
                                                >
                                                    <option value="">Select</option>
                                                    {bindInterviewRound()}
                                                </select>
                                            ) : (
                                                <input
                                                    className="form-control hive-form-control custom-textfield regular-text"
                                                    id="interview_round_id"
                                                    value={interviewData.interview_round_name}
                                                    readOnly
                                                />
                                            )}
                                            <span style={{ color: 'red' }}>{interviewRoundValidation}</span>
                                        </div>
                                        <div className="col-md-8 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="interviewer">
                                                Interviewer(s)<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <Select
                                                className="dropdown"
                                                name="interviewer"
                                                maxMenuHeight={150}
                                                placeholder="Select Interviewers"
                                                value={selectedPeopleList}
                                                options={showEmployee}
                                                onChange={handleChange}
                                                isMulti
                                                isClearable
                                            />
                                            <span style={{ color: 'red' }}>{interviewerValidation}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="candidate">
                                                Candidate(s)<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <Select
                                                name="candidates"
                                                id="candidates"
                                                placeholder="Select attendees"
                                                value={selectedCandidate}
                                                isMulti
                                                isDisabled
                                            />
                                            <span style={{ color: 'red' }}>{candidatesValidation}</span>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="date">
                                                Date<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                min={minDate}
                                                onKeyDown={(e) => {
                                                    e.preventDefault();
                                                  }}
                                                className="form-control hive-form-control custom-textfield regular-text"
                                                onChange={onInterviewValue}
                                                id="interview_date"
                                                value={moment(interviewData.interview_date).format('YYYY-MM-DD')}
                                            />
                                            <span style={{ color: 'red' }}>{dateValidation}</span>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="s-time">
                                                Start Time<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                onChange={onInterviewValue}
                                                value={interviewData.local_start_time}
                                                className="font-14 regular-text form-select hive-form-select image-none custom-textfield"
                                                id="local_start_time"
                                                type="time"
                                            />
                                            <span style={{ color: 'red' }}>{startTimeValidation}</span>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="e-time">
                                                End Time<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                onChange={onInterviewValue}
                                                value={interviewData.local_end_time}
                                                min={interviewData.start_time}
                                                className="font-14 regular-text form-select hive-form-select image-none custom-textfield"
                                                id="local_end_time"
                                                type="time"
                                            />
                                            <span style={{ color: 'red' }}>{endTimeValidation}</span>
                                        </div>
                                    </>
                                )}
                                <div className="col-md-12 d-flex justify-content-end mt-5">
                                    <button
                                        className="btn hive-btn-secondary me-2"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                        onClick={interviewCancelClick}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn hive-btn-primary"
                                        onClick={scheduleInterviewClick}
                                    >
                                        Schedule
                                    </button>
                                </div>
                            </div>
                        </div>
                        {!isLoadingLoader && <Loader isLoading={isLoadingLoader} />}
                    </div>
                    <div className="overlay"></div>
                </>
            )}
        </div>
    )
}

export default CandidateInterview;

